import React, { useState, useEffect ,useRef} from 'react';
import {
  Box, Container, Typography, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  IconButton, Chip, Grid, CircularProgress, Paper, Divider, List, ListItem, ListItemIcon, ListItemText, Badge,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ToggleButton, ToggleButtonGroup,
  TextField, InputAdornment, MenuItem, Select, FormControl, InputLabel,Collapse, Alert,Drawer,Stack,
} from '@mui/material';
import {
  Close as CloseIcon, LocalPharmacy as PillIcon, Person as UserIcon, Phone as PhoneIcon,
  LocationOn as MapPinIcon, CalendarToday as CalendarIcon, Notifications as BellIcon,
  Error as AlertCircleIcon, Inventory as PackageIcon, CheckCircle as CheckCircleIcon,
  Cancel as XCircleIcon, Schedule as ClockIcon, LocalShipping as TruckIcon,
  Description as DescriptionIcon, Download as DownloadIcon,
  ViewModule as ViewModuleIcon, TableChart as TableChartIcon, Phone, 
  Search as SearchIcon, FilterList as FilterListIcon,  CallSplit as CallSplitIcon, 
  ExpandMore as ExpandMoreIcon, 
  Visibility,
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import PersonIcon from '@mui/icons-material/Person';
import CustomDialog from '../../CustomDialog';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { apiRequest } from '../../fetchSetup';
import axios from 'axios';
import Pagination from "@mui/material/Pagination";
import AssignAgent from "./AssignAgent";
import PaymentPendingChip from "../OrderDetailsPage/PaymentPendingChip";
import { registerFetchedOrders, isOrderUnseen, markOrderSeen } from '../../utils/orderNotifications';
const MEDICINE_ORDERS_ENDPOINT = process.env.REACT_APP_ADMIN_MEDICINE_ORDERS;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const NOTIFICATION_URL = process.env.REACT_APP_STOCK_NOTIFICATION_ENDPOINT

const MedicineOrdersScreen = () => {
  const [selectedOrder, setSelectedOrder] = useState(null);
 
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [customDialog, setCustomDialog] = useState({ 
    show: false, message: '', type: 'success', title: 'Notification' 
  });
  const [medicineOrders, setMedicineOrders] = useState([]);
  const [newPrice, setNewPrice] = useState('');
  const [ordersTree, setOrdersTree] = useState([]);
  const [viewMode, setViewMode] = useState('card');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  
  const [prescriptionViewerOpen, setPrescriptionViewerOpen] = useState(false);
  const [selectedPrescriptionUrl, setSelectedPrescriptionUrl] = useState('');
  const [prescriptionType, setPrescriptionType] = useState('image');
  const [prescriptionFiles, setPrescriptionFiles] = useState({});
  const [loadingPrescriptions, setLoadingPrescriptions] = useState({});
  
  const [agentDetails, setAgentDetails] = useState(null);
  const [loadingAgent, setLoadingAgent] = useState(false);

const [splitDialogOpen, setSplitDialogOpen] = useState(false);
const [splittingOrder, setSplittingOrder] = useState(false);
const [selectedItemsForSplit, setSelectedItemsForSplit] = useState([]);
const [splitReason, setSplitReason] = useState('');
const [expandedOrders, setExpandedOrders] = useState({});
const [childOrders, setChildOrders] = useState({});
const [loadingChildren, setLoadingChildren] = useState({});

const [orderHistory, setOrderHistory] = useState([]);
const [currentViewOrder, setCurrentViewOrder] = useState(null);

const [notifications, setNotifications] = useState([]);
const [notificationDrawer, setNotificationDrawer] = useState(false);
const [unreadCount, setUnreadCount] = useState(0);
const [loadingNotifications, setLoadingNotifications] = useState(false);
const [expandedIssues, setExpandedIssues] = useState({}); 
const ordersFetchedRef       = useRef(false);
const notificationsFetchedRef = useRef(false);
const lastFetchedOrdersKey   = useRef('');
const [errors, setErrors] = useState({});
const [returnDialogOpen, setReturnDialogOpen] = useState(false);
const [returnItems, setReturnItems] = useState([]);
const [returnReason, setReturnReason] = useState("");
const [processingReturn, setProcessingReturn] = useState(false);
const [refundMethod, setRefundMethod] = useState("cash");
const [returnAllItems, setReturnAllItems] = useState(false);

// ─── NEW: Patient edit states ───────────────────────────────────────────────
const [editingPatient, setEditingPatient] = useState(false);
const [patientForm, setPatientForm] = useState({});
const [savingPatient, setSavingPatient] = useState(false);
// ────────────────────────────────────────────────────────────────────────────
const [page, setPage] = useState(1);
const [debouncedSearch, setDebouncedSearch] = useState("");
const [limit] = useState(9);
const [totalPages, setTotalPages] = useState(1);
const [totalOrders,setTotalOrders]=useState(0)
const [communities, setCommunities] = useState([]);
const [selectedCommunity, setSelectedCommunity]=useState("")
const GET_AGENT_API = `${process.env.REACT_APP_ASSGINED_DELIVERY_AGENT}`;
useEffect(() => {
  if (ordersFetchedRef.current) return;
  ordersFetchedRef.current = true;
  fetchOrders();
  fetchNotifications();
}, []);
const notifPollRef = useRef(null);
useEffect(() => {
  const schedulePoll = () => {
    notifPollRef.current = setTimeout(async () => {
      await fetchNotifications();
      schedulePoll(); // reschedule only after fetch completes
    }, 30000);
  };
  schedulePoll();
  return () => clearTimeout(notifPollRef.current);
}, []);
 const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "success",
    });
const API_URL = process.env.REACT_APP_API

useEffect(() => {
    fetchCommunities()
   },[])
  const fetchCommunities = async () => {
  
      try {
  
        const response = await axios.get(
          `${API_URL}/community/config`
        );
  
        setCommunities(
          response.data.communities || []
        );

        sessionStorage.setItem('communities',JSON.stringify(response.data.communities))
      } catch (error) {
  
        console.error(
          "Error fetching communities:",
          error
        );
  
        showSnackbar(
          "Failed to load communities",
          "error"
        );
  
      } 
    };
  
const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };
useEffect(() => {
  if (returnAllItems) {
    // Select all quantities
    setReturnItems((prev) =>
      prev.map((item) => ({
        ...item,
        return_quantity: item.ordered_quantity,
      }))
    );
  } else {
    // Optional: reset all quantities to 0 when unchecked
    setReturnItems((prev) =>
      prev.map((item) => ({
        ...item,
        return_quantity: 0,
      }))
    );
  }
}, [returnAllItems]);
const fetchNotifications = async () => {
  setLoadingNotifications(true);
  try {
    const response = await apiRequest(`${NOTIFICATION_URL}/stock`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch notifications');
    }
    
    const data = await response.json();
    
    console.log(' Notifications fetched:', data);
    
    setNotifications(data.notifications || []);
    setUnreadCount(data.unread_count || 0);
    
  } catch (error) {
    console.error('Error fetching notifications:', error);
  } finally {
    setLoadingNotifications(false);
  }
};

const markNotificationRead = async (notificationId) => {
  try {
    const response = await apiRequest(
      `${NOTIFICATION_URL}/${notificationId}/mark-read`,
      { method: 'PUT' }
    );
    
    if (!response.ok) {
      throw new Error('Failed to mark notification as read');
    }
    
    // Refresh notifications
    await fetchNotifications();
    
  } catch (error) {
    console.error('Error marking notification read:', error);
  }
};


const handleOpenReturnDialog = () => {
  const mappedItems = selectedOrder.items.map(item => ({
    medicine_id: item.medicine_id,
    medicine_name: item.medicine_name,
    ordered_quantity: item.quantity,
    return_quantity: 0,
    price: item.price,
    total_price: item.total_price
  }));

  setReturnItems(mappedItems);
  setReturnDialogOpen(true);
};

const handleCloseReturnDialog = () => {
  setReturnDialogOpen(false);
  setReturnReason("");
};

const handleReturnQtyChange = (index, value) => {
  const qty = parseInt(value) || 0;

  setReturnItems(prev =>
    prev.map((item, idx) =>
      idx === index
        ? {
            ...item,
            return_quantity: Math.min(
              qty,
              item.ordered_quantity
            )
          }
        : item
    )
  );
};

const handleSubmitReturn = async () => {
  try {
    setProcessingReturn(true);

    // If user selected "Return All"
    let itemsToReturn = [];

    if (returnAllItems) {
      itemsToReturn = selectedOrder.items.map(item => ({
        medicine_id: item.medicine_id,
        quantity:
          item.quantity - (item.returned_quantity || 0),
        reason: returnReason || "Full order return"
      }));
    } else {
      // Partial return
      itemsToReturn = returnItems
        .filter(item => item.return_quantity > 0)
        .map(item => ({
          medicine_id: item.medicine_id,
          quantity: item.return_quantity,
          reason:
            item.return_reason ||
            returnReason ||
            "Returned by admin"
        }));
    }

    // Remove invalid quantities
    itemsToReturn = itemsToReturn.filter(
      item => item.quantity > 0
    );

    if (itemsToReturn.length === 0) {
      showCustomDialog(
        "Please select at least one item to return",
        "warning"
      );
      return;
    }

    const token = sessionStorage.getItem("token");

    const response = await axios.post(
      `${process.env.REACT_APP_MEDICINE_API_URL}/medicine-orders/${selectedOrder.order_id}/return-items`,
      {
        items: itemsToReturn,
        refund_method: refundMethod || "cash",
        refund_reason: returnReason,
        processed_by: "admin"
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    setSelectedOrder(response.data?.order)

    showCustomDialog(
      response.data?.message || "Items returned successfully",
      "success"
    );

    console.log("Return Response:", response.data);
    setReturnDialogOpen(false);

    fetchOrders();


  } catch (error) {
    console.error("Return Error:", error);

    showCustomDialog(
      error.response?.data?.error ||
      error.response?.data?.message ||
      "Failed to process return",
      "error"
    );
  } finally {
    setProcessingReturn(false);
  }
};

const markAllNotificationsRead = async () => {
  try {
    const response = await apiRequest(
      `${NOTIFICATION_URL}/mark-all-read`,
      { method: 'PUT' }
    );
    
    if (!response.ok) {
      throw new Error('Failed to mark all notifications as read');
    }
    
    // Refresh notifications
    await fetchNotifications();
    
  } catch (error) {
    console.error('Error marking all notifications read:', error);
  }
};

const deleteNotification = async (notificationId) => {
  try {
    const response = await apiRequest(
      `${NOTIFICATION_URL}/${notificationId}`,
      { method: 'DELETE' }
    );
    
    if (!response.ok) {
      throw new Error('Failed to delete notification');
    }
    
    // Refresh notifications
    await fetchNotifications();
    
  } catch (error) {
    console.error('Error deleting notification:', error);
  }
};

const handleNotificationClick = (notification) => {
  // Mark as read
  if (!notification.is_read) {
    markNotificationRead(notification.notification_id);
  }
  
  // Find the order
  const order = medicineOrders.find(o => o.order_id === notification.order_id);
  
  if (order) {
    handleOpenDialog(order);
    setNotificationDrawer(false);
  } else {
    showCustomDialog(
      `Order ${notification.order_id} not found. It may have been processed.`,
      'warning',
      'Order Not Found'
    );
  }
};


const handleOpenSplitDialog = () => {
  // Initialize items with split quantities
  const itemsWithSplitQty = selectedOrder.items.map(item => ({
    ...item,
    original_quantity: item.quantity,
    keep_quantity: item.quantity, 
    split_quantity: 0, 
  }));
  setSelectedItemsForSplit(itemsWithSplitQty);
  setSplitDialogOpen(true);
};
// Handle quantity change for keep/split
const handleQuantityChange = (index, field, value) => {
  const updatedItems = [...selectedItemsForSplit];
  const item = updatedItems[index];
  
  let newValue = parseInt(value) || 0;
  
  // Ensure value doesn't exceed original quantity or go below 0
  if (newValue < 0) newValue = 0;
  if (newValue > item.original_quantity) newValue = item.original_quantity;
  
  if (field === 'keep_quantity') {
    item.keep_quantity = newValue;
    item.split_quantity = item.original_quantity - newValue;
  } else if (field === 'split_quantity') {
    item.split_quantity = newValue;
    item.keep_quantity = item.original_quantity - newValue;
  }
  
  setSelectedItemsForSplit(updatedItems);
};
// Quick action: Move all quantity to split
const handleMoveAllToSplit = (index) => {
  const updatedItems = [...selectedItemsForSplit];
  updatedItems[index].split_quantity = updatedItems[index].original_quantity;
  updatedItems[index].keep_quantity = 0;
  setSelectedItemsForSplit(updatedItems);
};

// Quick action: Keep all quantity
const handleKeepAll = (index) => {
  const updatedItems = [...selectedItemsForSplit];
  updatedItems[index].keep_quantity = updatedItems[index].original_quantity;
  updatedItems[index].split_quantity = 0;
  setSelectedItemsForSplit(updatedItems);
};

// Submit split order with quantity validation
const handleSubmitSplitOrder = async () => {
  // Prepare items for API
  const itemsToKeep = selectedItemsForSplit
    .filter(item => item.keep_quantity > 0)
    .map(item => ({
      medicine_id: item.medicine_id,
      quantity: item.keep_quantity
    }));
  
  const itemsToSplit = selectedItemsForSplit
    .filter(item => item.split_quantity > 0)
    .map(item => ({
      medicine_id: item.medicine_id,
      quantity: item.split_quantity
    }));
  
  // Validation
  if (itemsToSplit.length === 0) {
    showCustomDialog('Please specify at least some quantity to split', 'error', 'Error');
    return;
  }
  
  if (itemsToKeep.length === 0) {
    showCustomDialog('At least some quantity must remain in the current order', 'error', 'Error');
    return;
  }
  
  // Calculate totals for confirmation
  const totalKeepItems = itemsToKeep.reduce((sum, item) => sum + item.quantity, 0);
  const totalSplitItems = itemsToSplit.reduce((sum, item) => sum + item.quantity, 0);
  
  if (!window.confirm(
    `Split Order Confirmation:\n\n` +
    `• Keep in current order: ${totalKeepItems} item(s)\n` +
    `• Split to new order: ${totalSplitItems} item(s)\n\n` +
    `Continue?`
  )) {
    return;
  }
  
  setSplittingOrder(true);
  try {
    const response = await apiRequest(
      `${process.env.REACT_APP_ADMIN_MEDICINE_ORDERS}/${selectedOrder.order_id}/split-order`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items_to_split: itemsToSplit,
          items_to_keep: itemsToKeep,
          split_reason: splitReason || 'Admin manual split - partial quantities'
        })
      }
    );
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to split order');
    }
    
    const result = await response.json();
    
    showCustomDialog(
      `Order split successfully!\n\n` +
      `New orders created: ${result.new_orders.map(o => o.order_id).join(', ')}\n` +
      `Items kept: ${result.kept_items_count}\n` +
      `Items split: ${result.split_items_count}`,
      'success',
      'Order Split'
    );
    
    // Refresh orders
    await fetchOrders();
    setSplitDialogOpen(false);
    handleCloseDialog();
    
  } catch (error) {
    console.error('Error splitting order:', error);
    showCustomDialog(`Failed to split order: ${error.message}`, 'error', 'Error');
  } finally {
    setSplittingOrder(false);
  }
};

const handleCloseSplitDialog = () => {
  setSplitDialogOpen(false);
  setSelectedItemsForSplit([]);
  setSplitReason('');
};

useEffect(() => {
  setPage(1); // reset to first page when filter changes
}, [statusFilter,searchQuery,selectedCommunity]);

useEffect(() => {
  fetchOrders(page, statusFilter);
}, [page, statusFilter,searchQuery,selectedCommunity]);



const fetchOrders = async (pageNumber = page,selectedStatus = statusFilter, limit = 9) => {
  setLoading(true);
  setError(null);
  try {
    //  CHANGED: Use new endpoint that returns parent + children
    let url = `${MEDICINE_ORDERS_ENDPOINT}/all-with-children?order_type=pharmacy&page=${pageNumber}&limit=${limit}`;

    if (selectedStatus !== "all") {
      url += `&status=${selectedStatus}`;
    }
    if (searchQuery.trim()) {
      url += `&search=${encodeURIComponent(searchQuery)}`;
    }
    if (selectedCommunity!=="all"){
      if (selectedCommunity.trim()) {
        url += `&community=${encodeURIComponent(selectedCommunity)}`;
      }
  }
    const response = await apiRequest(url);

   
    
    if (!response.ok) throw new Error('Failed to fetch medicine orders');
    const data = await response.json();
    
    console.log(' Fetched orders:', data);

    // ✅ ADD THIS DEBUG CODE:
    data.orders.forEach(order => {
      if (order.delivery_issues && order.delivery_issues.length > 0) {
        console.log(`🚨 Order ${order.order_id} has ${order.delivery_issues.length} issue(s):`, order.delivery_issues);
      }
    });
        
    setTotalPages(data.total_pages || 1);
    setPage(data.current_page)
    setTotalOrders(data.total_orders)
    // Keep original flat array for filtering/searching
    setMedicineOrders(data.orders || []);
    registerFetchedOrders('medicine',(data.orders || []).map(o => ({ id: o.order_id, status: o.order_status })) 
  );
    
    //  NEW: Group orders into parent-child tree structure
    const groupedOrders = []
    for (let i = 0; i < data.orders.length; i++) {
      const order = data.orders[i];
      
      if (order.is_parent) {
        // Start new parent group
        groupedOrders.push({
          parent: order,
          children: []
        });
      } else if (order.is_child && groupedOrders.length > 0) {
        // Add child to the last parent group
        groupedOrders[groupedOrders.length - 1].children.push(order);
      }
    }
    
    setOrdersTree(groupedOrders);
    console.log(' Orders tree structure:', groupedOrders);
    
  } catch (err) {
    console.error('Error fetching orders:', err);
    setError(err.message || 'Failed to load orders');
  } finally {
    setLoading(false);
  }
};

  const fetchAgentDetails = async (agentId) => {
    if (!agentId) {
      setAgentDetails(null);
      return;
    }
    
    setLoadingAgent(true);
    try {
      const response = await apiRequest(`${GET_AGENT_API}/${agentId}`);
      if (response.ok) {
        const data = await response.json();
        setAgentDetails(data);
      } else {
        setAgentDetails(null);
      }
    } catch (error) {
      console.error("Error fetching agent details:", error);
      setAgentDetails(null);
    } finally {
      setLoadingAgent(false);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedOrder(null);
    setCurrentViewOrder(null);
    setOrderHistory([]);
    setAgentDetails(null);
    setEditingPatient(false);
    setPatientForm({});
    fetchOrders();
  };

  const showCustomDialog = (message, type = 'success', title = 'Notification') => {
    setCustomDialog({ show: true, message, type, title });
  };

  const handleCloseCustomDialog = () => {
    setCustomDialog({ show: false, message: '', type: 'success', title: 'Notification' });
  };

  const getStatusConfig = (status) => {
    const configs = {
      completed: { color: 'success', icon: <CheckCircleIcon />, label: 'Completed' },
      delivered: { color: 'success', icon: <CheckCircleIcon />, label: 'Delivered' },
      confirmed: { color: 'info', icon: <ClockIcon />, label: 'Confirmed' },
      bill_generated: { color: 'info', icon: <PillIcon />, label: 'Bill Generated' },
      processing: { color: 'info', icon: <ClockIcon />, label: 'Processing' },
      pending: { color: 'warning', icon: <ClockIcon />, label: 'Pending' },
      awaiting_bill: { color: 'warning', icon: <ClockIcon />, label: 'Pending' },
      cancelled: { color: 'error', icon: <XCircleIcon />, label: 'Cancelled' },
      dispatched: { color: 'secondary', icon: <TruckIcon />, label: 'Dispatched' },
      partially_fulfilled: { color: 'warning', icon: <CallSplitIcon />, label: 'Partial' },
    };
    return configs[status] || { color: 'default', icon: null, label: status };
  };

  const updateOrderStatus = async (orderId, newStatus) => {
    if (newStatus==='returned' || newStatus==='partially_returned') {
      showCustomDialog("Can't change status to Return before returning the order","info","Info")
    return
    }
    if(newStatus==='cancelled'){
      try{
        setUpdating(true);
      const token = sessionStorage.getItem("token");
      const response = await axios.put(`${process.env.REACT_APP_CREATE_MEDICINE_ORDER}/${orderId}/cancel`,{
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
      const data=response.data
       await fetchOrders();
       if (selectedOrder?.order_id === orderId) setSelectedOrder({ ...selectedOrder, order_status: newStatus });
          showCustomDialog("Order Cancelled","success","Success")
           setUpdating(false);
          return
          
      }catch (err) {
        setUpdating(false);
      showCustomDialog('Failed to cancel the order:err') 
    }
    }
    else{
    setUpdating(true);
    try {
      const response = await apiRequest(`${process.env.REACT_APP_ADMIN_MEDICINE_ORDERS}/${orderId}/status`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_status: newStatus })
      });
      if (!response.ok) throw new Error('Failed to update order status');
      await fetchOrders();
      if (selectedOrder?.order_id === orderId) setSelectedOrder({ ...selectedOrder, order_status: newStatus });
      showCustomDialog(newStatus === 'delivered' ? 'Order marked as delivered! Parent order status updated automatically.' : 'Order status updated successfully!', 'success', 'Success');
    } catch (err) {
      showCustomDialog('Failed to update order status: ' + err.message, 'error', 'Error');
    } finally {
      setUpdating(false);
    }
  }
  };

  // ─── NEW: Save patient information ──────────────────────────────────────────
  const handleStartEditPatient = () => {
    setPatientForm({
      name: selectedOrder?.patient_details?.name || '',
      age: selectedOrder?.patient_details?.age || '',
      gender: selectedOrder?.patient_details?.gender || '',
      phone: selectedOrder?.patient_details?.phone || '',
      doctorname: selectedOrder?.patient_details?.doctorname || '',
    });
    setEditingPatient(true);
  };

  const handleCancelEditPatient = () => {
    setEditingPatient(false);
    setPatientForm({});
  };

  const handleSavePatient = async () => {
  
    if (errors.phone) {
      showCustomDialog("Phone number must be 10 digits","error");
    }
    else{
    setSavingPatient(true);
    try {
      const response = await apiRequest(
        `${MEDICINE_ORDERS_ENDPOINT}/${selectedOrder.order_id}/patient-details`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ patient_details: patientForm }),
        }
      );

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.message || 'Failed to update patient details');
      }

      // Optimistically update local state
      const updatedOrder = {
        ...selectedOrder,
        patient_details: { ...selectedOrder.patient_details, ...patientForm },
      };
      setSelectedOrder(updatedOrder);
      setCurrentViewOrder(updatedOrder);

      // Also update the flat list so cards reflect changes
      setMedicineOrders(prev =>
        prev.map(o => o.order_id === selectedOrder.order_id ? updatedOrder : o)
      );

      setEditingPatient(false);
      setPatientForm({});
      showCustomDialog('Patient information updated successfully!', 'success', 'Saved');
    } catch (err) {
      console.error('Error saving patient details:', err);
      showCustomDialog('Failed to save patient details: ' + err.message, 'error', 'Error');
    } finally {
      setSavingPatient(false);
    }
  }
  };
  // ────────────────────────────────────────────────────────────────────────────

  const sendNotification = () => {
    showCustomDialog(`Notification sent to ${selectedOrder.user_email}`, 'success', 'Notification Sent');
  };

  const formatToIST = (dateString) => {
    if (!dateString) return 'N/A';
  
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
  
    return date.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };
  
  
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
  
    const date = new Date(dateString);
  
    if (isNaN(date.getTime())) return 'N/A';
  
    // Add 5 hours 30 minutes
    date.setMinutes(date.getMinutes() + 330);
  
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };
  
    // Update the fetchPrescriptionsByOrderId function:
    const fetchPrescriptionsByOrderId = async (orderId) => {
      console.log("🔍 Fetching prescriptions for order:", orderId);
      
      // If already fetched, return cached data
      if (prescriptionFiles[orderId]) {
        console.log("📂 Using cached prescription files");
        return prescriptionFiles[orderId];
      }
      
      setLoadingPrescriptions(prev => ({ ...prev, [orderId]: true }));
      
      try {
        // Try the new endpoint first
        const response = await apiRequest(`${process.env.REACT_APP_PRESCRIPTION_BY_MEDICINE_URL}${orderId}`);
        if (!response.ok) {
          console.warn("⚠️ Prescription API failed, trying fallback");
          throw new Error('Failed to fetch prescriptions');
        }
        
        const data = await response.json();
        console.log("📥 Prescription API response:", data);
        
        let files = [];
        
        // Handle different response formats
        if (data.files && Array.isArray(data.files)) {
          files = data.files;
        } else if (Array.isArray(data)) {
          files = data;
        } else if (data.url) {
          files = [{ url: data.url }];
        }
        
        console.log(" Extracted files:", files);
        setPrescriptionFiles(prev => ({ ...prev, [orderId]: files }));
        return files;
        
      } catch (err) {
        console.error(`❌ Error fetching prescriptions for order ${orderId}:`, err);
        return [];
      } finally {
        setLoadingPrescriptions(prev => ({ ...prev, [orderId]: false }));
      }
    };
  
  // Update the hasPrescription function - remove the prescription-related fields check
  const hasPrescription = (order) => {
    //console.log(" Checking prescription for order:", order.order_id);
    
    // 1. Check direct prescription_url field
    if (order.prescription_url && order.prescription_url.trim() !== '') {
      console.log("Found prescription_url:", order.prescription_url);
      return true;
    }
    
    // 2. Check prescription_urls array field
    if (order.prescription_urls && Array.isArray(order.prescription_urls) && order.prescription_urls.length > 0) {
      console.log(" Found prescription_urls array:", order.prescription_urls);
      return true;
    }
    
    // 3. Check fetched prescription files
    if (prescriptionFiles[order.order_id] && prescriptionFiles[order.order_id].length > 0) {
      console.log(" Found fetched prescription files:", prescriptionFiles[order.order_id]);
      return true;
    }
    
   // console.log(" No prescription found");
    return false; // Don't check for prescription_verified or prescription_status
  };
  
  const getPrescriptionUrls = (order) => {
    let urls = [];
    console.log(" Getting prescription URLs for order:", order.order_id);
    
    // 1. Check for direct prescription_url
    if (order.prescription_url && order.prescription_url.trim() !== '') {
      console.log(" Adding direct prescription_url:", order.prescription_url);
      urls.push(order.prescription_url);
    }
    
    // 2. Check for prescription_urls array
    if (order.prescription_urls && Array.isArray(order.prescription_urls)) {
      console.log(" Adding prescription_urls array:", order.prescription_urls);
      urls = [...urls, ...order.prescription_urls];
    }
    
    // 3. Check fetched files (from separate API)
    if (prescriptionFiles[order.order_id]) {
      console.log(" Adding fetched files:", prescriptionFiles[order.order_id]);
      prescriptionFiles[order.order_id].forEach(file => {
        if (file.url) urls.push(file.url);
      });
    }
    
    // Filter out empty/null URLs AND temp URLs
    const filteredUrls = urls.filter(url => {
      if (!url || typeof url !== 'string' || url.trim() === '') {
        return false;
      }
      
      // Check if URL is accessible (not temp/deleted)
      const isTempUrl = url.includes('temp_');
      const isRenamedUrl = url.includes(order.order_id); // Check if it contains order ID
      
      
      // Prefer renamed URLs over temp URLs
      if (isRenamedUrl) {
        console.log(`Keeping renamed URL: ${url}`);
        return true;
      }
      
      // If it's a temp URL, check if we also have a renamed version
      if (isTempUrl) {
        const hasRenamedVersion = urls.some(otherUrl => 
          otherUrl !== url && otherUrl.includes(order.order_id)
        );
        
        if (hasRenamedVersion) {
          console.log(`Skipping temp URL (has renamed version): ${url}`);
          return false;
        } else {
          console.log(`Keeping temp URL (no renamed version): ${url}`);
          return true;
        }
      }
      
      console.log(`Keeping regular URL: ${url}`);
      return true;
    });
    
    console.log("Final filtered URLs:", filteredUrls);
    return filteredUrls;
  };
  
  
  
  
  
    const buildPrescriptionUrl = (url) => {
      if (!url) return '';
      
      if (url.startsWith('http')) return url;
      if (url.startsWith('/prescriptions/')) {
        return `${BACKEND_URL}${url}`;
      }
      
      return url;
    };


  const handleOpenDialog = async (order) => {
    markOrderSeen('medicine', order.order_id);
    setCurrentViewOrder(order);
    setSelectedOrder(order);
    setNewPrice(order.total_amount || '');
    setDialogOpen(true);
    setOrderHistory([]);
    setEditingPatient(false);
    setPatientForm({});

    // Check for prescription
    if (order.prescription_url) {
      console.log("Order has prescription_url:", order.prescription_url);
    }
    if (order.prescription_urls) {
      console.log("Order has prescription_urls:", order.prescription_urls);
    }
    await fetchPrescriptionsByOrderId(order.order_id);
    await fetchAgentDetails(order.assigned_agent_id);
  };

const handleNavigateToChildOrder = async (childOrder) => {
  markOrderSeen('medicine', childOrder.order_id); 
  setOrderHistory(prev => [...prev, currentViewOrder]);
  setCurrentViewOrder(childOrder);
  setSelectedOrder(childOrder);
  setNewPrice(childOrder.total_amount || '');
  setEditingPatient(false);
  setPatientForm({});
  await fetchPrescriptionsByOrderId(childOrder.order_id);
  await fetchAgentDetails(childOrder.assigned_agent_id);
};

const handleGoBack = async () => {
  if (orderHistory.length === 0) return;
  const previousOrder = orderHistory[orderHistory.length - 1];
  setOrderHistory(prev => prev.slice(0, -1));
  setCurrentViewOrder(previousOrder);
  setSelectedOrder(previousOrder);
  setNewPrice(previousOrder.total_amount || '');
  setEditingPatient(false);
  setPatientForm({});
  await fetchPrescriptionsByOrderId(previousOrder.order_id);
  await fetchAgentDetails(previousOrder.assigned_agent_id);
};

const getCurrentChildOrders = () => {
  if (!currentViewOrder) return [];
  // Find the parent order in ordersTree
  for (const { parent, children } of ordersTree) {
    if (parent.order_id === currentViewOrder.order_id) {
      return children || [];
    }
  }
  return [];
};
  
    const getFileType = (url) => {
      if (!url) return 'unknown';
      
      // Extract file extension
      const urlWithoutQuery = url.split('?')[0];
      const extension = urlWithoutQuery.split('.').pop().toLowerCase();
      
      if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff'].includes(extension)) {
        return 'image';
      } else if (extension === 'pdf') {
        return 'pdf';
      } else if (['doc', 'docx', 'txt', 'rtf'].includes(extension)) {
        return 'document';
      }
      return 'unknown';
    };
    
    const handleViewPrescription = (url) => {
      const fullUrl = buildPrescriptionUrl(url);
      const fileType = getFileType(url);
      setSelectedPrescriptionUrl(fullUrl);
      setPrescriptionType(fileType);
      setPrescriptionViewerOpen(true);
    };
    
  
    const handleDownloadPrescription = async (orderId, fileUrlOrName) => {
      try {
        if (!orderId || !fileUrlOrName) {
          showCustomDialog("Invalid download parameters", "error", "Error");
          return;
        }
    
        const filename = fileUrlOrName.includes("/")
          ? fileUrlOrName.split("/").pop()
          : fileUrlOrName;
    
        const apiUrl = `${BACKEND_URL}/api/flask/prescription/prescription-download/${orderId}/${encodeURIComponent(filename)}`;
        console.log("api url for download prescription",apiUrl)
    
        const res = await apiRequest(apiUrl);
        console.log("response for dowload url",res)
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || "Failed to get download URL");
        }
  
    
        const data = await res.json();
    
        const downloadUrl =
          data.download_url ||
          data.url;
    
        if (!downloadUrl) {
          throw new Error("Download URL missing from response");
        }
    
        window.open(downloadUrl, "_blank");
    
      } catch (err) {
        console.error("Prescription download error:", err);
        showCustomDialog("Failed to download prescription", "error", "Error");
      }
    };

  const handleClosePrescriptionViewer = () => {
    setPrescriptionViewerOpen(false);
    setSelectedPrescriptionUrl('');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleViewModeChange = (event, newMode) => {
    if (newMode !== null) {
      setViewMode(newMode);
    }
  };






const getFilteredOrders = () => {
  let filtered = [...medicineOrders];

  return filtered;
};
  
  // // Filter and search logic
  // const getFilteredOrders = () => {
  //   let filtered = [...medicineOrders];

  //   // Apply status filter
  //   if (statusFilter !== 'all') {
  //     filtered = filtered.filter(order => order.order_status === statusFilter);
  //   }

  //   // Apply search query
  //   if (searchQuery.trim() !== '') {
  //     const query = searchQuery.toLowerCase();
  //     filtered = filtered.filter(order => 
  //       order.order_id.toLowerCase().includes(query) ||
  //       order.user_email.toLowerCase().includes(query) ||
  //       order.user_phone.includes(query) ||
  //       order.delivery_address?.full_name?.toLowerCase().includes(query)
  //     );
  //   }

  //   return filtered;
  // };
  const handleInvoiceDownload=async(order_id)=>{
        try {
              const token = sessionStorage.getItem("token");
  
              const response = await axios.get(
                `${process.env.REACT_APP_API_INVOICE}/invoice/download/${order_id}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              
            const download_url=response.data.download_url
              window.open(download_url, "_blank");
  
            } catch (error) {
              console.error("Invoice download failed:", error);
            }
  }
  








// Add after formatDate function
const calculateItemGST = (item) => {
  const cgst = item.cgst || 0;
  const sgst = item.sgst || 0;
  const igst = item.igst || 0;
  
  const gstRate = igst > 0 ? igst : (cgst + sgst);
  const totalPrice = item.total_price || 0;
  
  // Price includes GST, so extract base price
  const basePrice = totalPrice / (1 + gstRate / 100);
  const gstAmount = totalPrice - basePrice;
  
  return {
    cgst,
    sgst,
    igst,
    gstRate,
    basePrice,
    gstAmount,
    cgstAmount: igst > 0 ? 0 : gstAmount / 2,
    sgstAmount: igst > 0 ? 0 : gstAmount / 2,
    igstAmount: igst > 0 ? gstAmount : 0,
    totalPrice
  };
};

const calculateOrderGST = (items) => {
  let totalBasePrice = 0;
  let totalCGST = 0;
  let totalSGST = 0;
  let totalIGST = 0;
  let totalGST = 0;

  items.forEach(item => {
    const itemGST = calculateItemGST(item);
    totalBasePrice += itemGST.basePrice;
    totalCGST += itemGST.cgstAmount;
    totalSGST += itemGST.sgstAmount;
    totalIGST += itemGST.igstAmount;
    totalGST += itemGST.gstAmount;
  });

  return {
    basePrice: totalBasePrice,
    cgst: totalCGST,
    sgst: totalSGST,
    igst: totalIGST,
    totalGST: totalGST
  };
};



  const getFilteredOrdersTree = () => {
    // First filter and sort the flat array
    const filtered = getFilteredOrders();
    
    // Then rebuild the tree structure
    const groupedOrders = [];
    for (let i = 0; i < filtered.length; i++) {
      const order = filtered[i];
      
      if (order.is_parent) {
        groupedOrders.push({
          parent: order,
          children: []
        });
      } else if (order.is_child && groupedOrders.length > 0) {
        groupedOrders[groupedOrders.length - 1].children.push(order);
      }
    }
    
    return groupedOrders;
  };

  const statusLabelMap = {
    awaiting_bill: "Pending",
    confirmed: "Confirmed",
    dispatched: "Dispatched",
    delivered: "Delivered",
    bill_generated: "Bill Generated",
    cancelled: "Cancelled",
    partially_fulfilled: "Partial",
    returned:"Returned",
    partially_returned:"Partially Returned"
  };

  const filteredOrders = getFilteredOrders();
  const filteredOrdersTree = getFilteredOrdersTree();
const paginatedOrdersTree = ordersTree;
const paginatedOrders = filteredOrders.slice(
  page * rowsPerPage,
  page * rowsPerPage + rowsPerPage
);
  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'grey.50' }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Typography variant="h6" color="text.secondary">Loading medicine orders...</Typography>
        </Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'grey.50', p: 2 }}>
        <Paper elevation={3} sx={{ p: 4, maxWidth: 400, textAlign: 'center' }}>
          <AlertCircleIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
          <Typography variant="h5" fontWeight="bold" gutterBottom>Error Loading Orders</Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>{error}</Typography>
        </Paper>
      </Box>
    );
  }



  const SummaryItem = ({ label, value, isCurrency = true, color = "text.primary" }) => (
    <Box
      sx={{
        p: 2,
        border: "1px solid #E0E0E0",
        borderRadius: 2,
        height: "100%",
        bgcolor: "#FAFAFA",
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ mt: 0.5, color }}
      >
        {isCurrency ? `₹${Number(value).toFixed(2)}` : value}
      </Typography>
    </Box>
  );





  
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header with View Toggle */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="#006D77" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PillIcon sx={{ fontSize: 40 }} />
              Medicine Orders
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage pharmacy medicine orders ({filteredOrders.length} of {totalOrders} orders)
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <IconButton 
      onClick={() => setNotificationDrawer(true)}
      sx={{
        bgcolor: unreadCount > 0 ? '#FEF3C7' : 'white',
        border: '2px solid',
        borderColor: unreadCount > 0 ? '#F59E0B' : '#E0E0E0',
        '&:hover': {
          bgcolor: unreadCount > 0 ? '#FDE68A' : '#F5F5F5'
        }
      }}
    >
      <Badge badgeContent={unreadCount} color="error">
        <BellIcon sx={{ color: unreadCount > 0 ? '#F59E0B' : '#757575' }} />
      </Badge>
    </IconButton>


          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleViewModeChange}
            sx={{
              bgcolor: 'white',
              '& .MuiToggleButton-root': {
                border: '1px solid #E0E0E0',
                '&.Mui-selected': {
                  bgcolor: '#006D77',
                  color: 'white',
                  '&:hover': { bgcolor: '#005560' }
                }
              }
            }}
          >
            <ToggleButton value="card">
              <ViewModuleIcon sx={{ mr: 1 }} />
              Card View
            </ToggleButton>
            <ToggleButton value="table">
              <TableChartIcon sx={{ mr: 1 }} />
              Table View
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        </Box>





{/*  ADD THIS NOTIFICATION DRAWER */}
<Drawer
  anchor="right"
  open={notificationDrawer}
  onClose={() => setNotificationDrawer(false)}
  PaperProps={{
    sx: {
      width: { xs: '100%', sm: 450 },
      boxShadow: '-4px 0 20px rgba(0,0,0,0.1)'
    }
  }}
>
  <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    {/* Header */}
    <Box sx={{ 
      p: 2.5, 
      bgcolor: '#006D77', 
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BellIcon sx={{ fontSize: 28 }} />
        <Box>
          <Typography variant="h6" fontWeight="bold">
            Stock Notifications
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.9 }}>
            {unreadCount} unread notification{unreadCount !== 1 ? 's' : ''}
          </Typography>
        </Box>
      </Box>
      <IconButton 
        onClick={() => setNotificationDrawer(false)}
        sx={{ color: 'white' }}
      >
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Actions */}
    {unreadCount > 0 && (
      <Box sx={{ p: 2, bgcolor: '#F9FAFB', borderBottom: '1px solid #E0E0E0' }}>
        <Button
          size="small"
          variant="outlined"
          onClick={markAllNotificationsRead}
          sx={{
            textTransform: 'none',
            borderColor: '#006D77',
            color: '#006D77',
            '&:hover': { bgcolor: '#E0F2F1' }
          }}
        >
          Mark all as read
        </Button>
      </Box>
    )}

    {/* Notifications List */}
    <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
      {loadingNotifications ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress sx={{ color: '#006D77' }} />
        </Box>
      ) : notifications.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <BellIcon sx={{ fontSize: 64, color: '#E0E0E0', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No Notifications
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You'll be notified when stock is received for pending orders
          </Typography>
        </Box>
      ) : (
        <List sx={{ p: 0 }}>
          {notifications.map((notification, index) => (
            <React.Fragment key={notification.notification_id}>
              <ListItem
                sx={{
                  bgcolor: notification.is_read ? 'white' : '#E3F2FD',
                  borderRadius: 2,
                  mb: 1.5,
                  border: '1px solid',
                  borderColor: notification.is_read ? '#E0E0E0' : '#006D77',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  '&:hover': {
                    transform: 'translateX(-4px)',
                    boxShadow: 3
                  }
                }}
                onClick={() => handleNotificationClick(notification)}
              >
                <ListItemIcon>
                  <Box sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    bgcolor: notification.is_read ? '#F5F5F5' : '#006D77',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <PackageIcon sx={{ 
                      color: notification.is_read ? '#9E9E9E' : 'white',
                      fontSize: 24
                    }} />
                  </Box>
                </ListItemIcon>

                <ListItemText
                  primary={
                    <Typography 
                      variant="body2" 
                      fontWeight={notification.is_read ? 500 : 700}
                      sx={{ mb: 0.5 }}
                    >
                      Stock Received: {notification.medicine_name}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography variant="caption" display="block" color="text.secondary">
                        Order ID: {notification.order_id}
                      </Typography>
                      <Typography variant="caption" display="block" color="success.main" sx={{ mt: 0.5 }}>
                        ✓ {notification.quantity_received} units received
                      </Typography>
                      {notification.po_number && (
                        <Typography variant="caption" display="block" color="text.secondary">
                          PO: {notification.po_number}
                        </Typography>
                      )}
                      <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
                        {formatDate(notification.created_at)}
                      </Typography>
                    </>
                  }
                />

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, ml: 1 }}>
                  {!notification.is_read && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        markNotificationRead(notification.notification_id);
                      }}
                      sx={{
                        bgcolor: '#C8E6C9',
                        '&:hover': { bgcolor: '#A5D6A7' }
                      }}
                    >
                      <CheckCircleIcon fontSize="small" sx={{ color: '#2E7D32' }} />
                    </IconButton>
                  )}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm('Delete this notification?')) {
                        deleteNotification(notification.notification_id);
                      }
                    }}
                    sx={{
                      bgcolor: '#FFEBEE',
                      '&:hover': { bgcolor: '#FFCDD2' }
                    }}
                  >
                    <XCircleIcon fontSize="small" sx={{ color: '#C62828' }} />
                  </IconButton>
                </Box>
              </ListItem>
            </React.Fragment>
          ))}
        </List>
      )}
    </Box>

    {/* Footer */}
    <Box sx={{ 
      p: 2, 
      borderTop: '1px solid #E0E0E0',
      bgcolor: '#F9FAFB',
      textAlign: 'center'
    }}>
      <Typography variant="caption" color="text.secondary">
        Notifications auto-refresh every 30 seconds
      </Typography>
    </Box>
  </Box>
</Drawer>





        {/* Search and Filter Section */}
        <Paper sx={{ p: 2, mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField
            placeholder="Search by Order ID, Name, Email, or Phone..."
            variant="outlined"
            size="small"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setSearchQuery(searchInput);
                setPage(1);
              }
            }}
            sx={{ 
              flex: { xs: '1 1 100%', sm: '1 1 auto' },
              minWidth: { xs: '100%', sm: '300px' },
              '& .MuiOutlinedInput-root': {
                bgcolor: 'white'
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#006D77' }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
              variant="contained"
              size="small"
              onClick={() => {
                setSearchQuery(searchInput);
                setPage(1);
              }}
              sx={{
                bgcolor: '#006D77',
                '&:hover': {
                  bgcolor: '#005560',
                },
                minWidth: 70,
              }}
            >
              Search
            </Button>
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel id="status-filter-label">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <FilterListIcon fontSize="small" />
                Filter by Community
              </Box>
            </InputLabel>
            <Select
              labelId="status-filter-label"
              value={selectedCommunity}
              label="Filter by Community"
              onChange={(e) => {
                setSelectedCommunity(e.target.value);
                setPage(1); // Reset to first page on filter change
              }}
              sx={{ bgcolor: 'white' }}
            >
              <MenuItem value="all">Community</MenuItem>
                {communities.map((community) => (
                  <MenuItem
                    key={community.name}
                    value={community.name}
                  >
                    {community.name}
                  </MenuItem>
                ))}

                </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel id="status-filter-label">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <FilterListIcon fontSize="small" />
                Filter by Status
              </Box>
            </InputLabel>
            <Select
              labelId="status-filter-label"
              value={statusFilter}
              label="Filter by Status"
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setPage(1); // Reset to first page on filter change
              }}
              sx={{ bgcolor: 'white' }}
            >
              <MenuItem value="all">All Statuses</MenuItem>
              <MenuItem value="awaiting_bill">Pending</MenuItem>
              <MenuItem value="partially_fulfilled">Partial Orders</MenuItem>
              <MenuItem value="confirmed">Confirmed</MenuItem>
              <MenuItem value="bill_generated">Bill Generated</MenuItem>
              <MenuItem value="dispatched">Dispatched</MenuItem>
              <MenuItem value="delivered">Delivered</MenuItem>
              <MenuItem value="cancelled">Cancelled</MenuItem>
              <MenuItem value="issue_reported">Delivery issues</MenuItem>
            </Select>
          </FormControl>

          {(searchQuery || selectedCommunity || statusFilter !== 'all') && (
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setSearchQuery('');
                setSearchInput('');
                setStatusFilter('all');
                setSelectedCommunity("all");
                setPage(1);
              }}
              sx={{
                borderColor: '#006D77',
                color: '#006D77',
                '&:hover': {
                  borderColor: '#005560',
                  bgcolor: 'rgba(0, 109, 119, 0.04)'
                }
              }}
            >
              Clear Filters
            </Button>
          )}
        </Paper>

        {filteredOrders.length === 0 ? (
          <Paper sx={{ p: 8, textAlign: 'center' }}>
            <PackageIcon sx={{ fontSize: 80, color: 'grey.300', mb: 2 }} />
            <Typography variant="h5" fontWeight="bold" color="text.secondary" gutterBottom>
              {searchQuery || selectedCommunity || statusFilter !== 'all' ? 'No Orders Match Your Search' : 'No Medicine Orders Found'}
            </Typography>
            {(searchQuery || selectedCommunity || statusFilter !== 'all') && (
              <Typography color="text.secondary" sx={{ mt: 1 }}>
                Try adjusting your search or filter criteria
              </Typography>
            )}
          </Paper>
        ) : viewMode === 'card' ? (
          /* CARD VIEW */

  /* CARD VIEW - WITH PARENT-CHILD SUPPORT */
  <>

  <Grid container spacing={3}>

    {/* {ordersTree.map(({ parent, children }) => { */}
    {/* {filteredOrdersTree.map(({ parent, children }) => {   */}
    {paginatedOrdersTree.map(({ parent, children }) => {
      const status = getStatusConfig(parent.order_status);
      const orderHasPrescription = hasPrescription(parent);
      const hasChildren = parent.has_children;
      const isExpanded = expandedOrders[parent.order_id];
      const isNew = isOrderUnseen('medicine', parent.order_id); 
      
      return (
        <Grid item xs={12} sm={6} md={4} key={parent.order_id}
            sx={{ display: "flex", minWidth: 0 }} >
          {/*  PARENT ORDER CARD */}
       
            <Card
              elevation={hasChildren ? 3 : 0}
              sx={{
                flex: 1,
                width: 350,
                minWidth: 0,         
                height: 350,           
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                borderRadius: 2.5,
                border: isNew ? '2px solid #f8e7e7' : '1px solid #006D77',   
                bgcolor: isNew ? '#FEF2F2' : 'inherit',                       
                transition: "all 0.3s ease",
                overflow: "hidden",   
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: hasChildren ? 8 : 4,
                  borderColor: isNew ? "#f1b4b4" : "#006d77"                  
                }
              }}
            >
            {/* Prescription Badge */}
            {orderHasPrescription && (
              <Badge
                badgeContent={<DescriptionIcon sx={{ fontSize: 16 }} />}
                color="primary"
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  '& .MuiBadge-badge': {
                    bgcolor: '#006D77',
                    width: 32,
                    height: 32,
                    borderRadius: '50%'
                  }
                }}
              />
            )}

            {/*  NEW: Child Orders Badge */}
            {hasChildren && (
              <Chip
                icon={<CallSplitIcon />}
                label={`${parent.child_order_count} splits`}
                size="small"
                color="info"
                sx={{
                  position: 'absolute',
                  top: 10,
                  left: 10,
                  fontWeight: 'bold'
                }}
              />
            )}
            
            <CardContent sx={{ cursor: 'pointer' }} onClick={() => handleOpenDialog(parent)}>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2, mt: hasChildren ? 3 : 0 }}>
                <Box>
                  <Typography variant="h6" color="#006D77" fontWeight="bold">
                    {parent.order_id}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                  Created At: {formatDate(parent.created_at)}
                  </Typography> <br/>
                  <Typography variant="caption" color="text.secondary">
                  Delivery Time: {formatToIST(parent.delivery_address?.delivery_time)}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.75 }}>
                  <Chip
                    icon={status.icon}
                    label={statusLabelMap[parent.order_status] || status.label}
                    color={status.color}
                    size="small"
                  />
                  <PaymentPendingChip order={parent} apiFetch={apiRequest} notify={showCustomDialog} />
                </Box>
              </Box>

              <Divider sx={{ my: 2 }} />

              <List dense disablePadding>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 32 }}><UserIcon fontSize="small" /></ListItemIcon>
                  <ListItemText primary={parent.patient_details.name } primaryTypographyProps={{ variant: 'body2', noWrap: true }} />
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 32 }}><PhoneIcon fontSize="small" /></ListItemIcon>
                  <ListItemText primary={parent.user_phone} primaryTypographyProps={{ variant: 'body2', noWrap: true }} />
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 32 }}><MapPinIcon fontSize="small" /></ListItemIcon>
                  <ListItemText primary={parent.delivery_address?.community_name ||  parent.delivery_address?.address_line1 || 'N/A'} primaryTypographyProps={{ variant: 'body2', noWrap: true }} />
                </ListItem>
              </List>

              <Divider sx={{ my: 2 }} />

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Total</Typography>
                <Typography variant="h5" color="#006D77" fontWeight="bold">
                  ₹{parent.total_amount?.toFixed(2) || '0.00'}
                </Typography>
              </Box>
            </CardContent>

          </Card>

          {/*  NEW: Child Orders - Collapsible */}
          {hasChildren && (
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <Box sx={{ mt: 2 }}>
                {children.map((childOrder) => (
                  <Card
                    key={childOrder.order_id}
                    elevation={2}
                    sx={{
                      ml: 2,
                      mb: 2,
                      borderLeft: '4px solid #F59E0B',
                      bgcolor: '#FFFEF7',
                      cursor: 'pointer', position: 'relative',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateX(4px)',
                        boxShadow: 6
                      }
                    }}
                    onClick={() => handleOpenDialog(childOrder)}
                  >
                {isOrderUnseen('medicine', childOrder.order_id) && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 10,
                      right: 10,
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      bgcolor: '#EF4444',
                      boxShadow: '0 0 0 3px white',
                      zIndex: 2,
                    }}
                  />
                )}
                    <CardContent>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box>
                          <Typography variant="subtitle1" fontWeight="bold" color="#F59E0B">
                            {childOrder.order_id}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Split Order • {childOrder.items?.length || 0} items
                          </Typography>
                        </Box>
                        <Chip
                          icon={getStatusConfig(childOrder.order_status).icon}
                          label={statusLabelMap[childOrder.order_status] || getStatusConfig(childOrder.order_status).label}
                          color={getStatusConfig(childOrder.order_status).color}
                          size="small"
                        />
                      </Box>

                      <Divider sx={{ my: 1 }} />

                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          {childOrder.items?.length || 0} medicines
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" color="#F59E0B">
                          ₹{childOrder.total_amount?.toFixed(2) || '0.00'}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            </Collapse>
          )}
        </Grid>
      );
    })}
  </Grid>


<Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
    <Pagination count={totalPages} page={page} onChange={(e, v) => fetchOrders(v, searchQuery)} color="primary" />
</Stack>


</>
        ) : (
          /* TABLE VIEW */
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 'calc(100vh - 400px)' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ bgcolor: '#006D77', color: 'white', fontWeight: 'bold' }}>Order ID</TableCell>
                    <TableCell sx={{ bgcolor: '#006D77', color: 'white', fontWeight: 'bold' }}>Date</TableCell>
                    <TableCell sx={{ bgcolor: '#006D77', color: 'white', fontWeight: 'bold' }}>Customer</TableCell>
                    <TableCell sx={{ bgcolor: '#006D77', color: 'white', fontWeight: 'bold' }}>Phone</TableCell>
                    <TableCell sx={{ bgcolor: '#006D77', color: 'white', fontWeight: 'bold' }}>Community</TableCell>
                    <TableCell sx={{ bgcolor: '#006D77', color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                    <TableCell sx={{ bgcolor: '#006D77', color: 'white', fontWeight: 'bold' }} align="right">Amount</TableCell>
                    <TableCell sx={{ bgcolor: '#006D77', color: 'white', fontWeight: 'bold' }} align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredOrders.map((order) => {
                    const status = getStatusConfig(order.order_status);
                    const orderHasPrescription = hasPrescription(order);
                    
                    return (
                      <TableRow 
                        key={order.order_id}
                        hover
                        sx={{ '&:hover': { bgcolor: 'rgba(0, 109, 119, 0.04)' } }}
                      >
                        <TableCell>
                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                            {isOrderUnseen('medicine', order.order_id) && (
                              <Box
                                sx={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: '50%',
                                  bgcolor: '#EF4444',
                                  flexShrink: 0,
                                }}
                              />
                            )}
                          <Typography variant="body2" fontWeight="600" color="#006D77">
                            {order.order_id}
                          </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">{formatDate(order.created_at)}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                            {order.user_email}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">{order.user_phone}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {order.delivery_address?.community_name || order.delivery_address?.address_line1 || 'N/A'}
                          </Typography>

                        </TableCell>
                        <TableCell>
                          <Chip 
                            icon={status.icon} 
                            label={statusLabelMap[order.order_status] || status.label}
                            color={status.color} 
                            size="small" 
                          />
                           <PaymentPendingChip order={order} apiFetch={apiRequest} notify={showCustomDialog} />
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body1" fontWeight="bold" color="#006D77">
                            ₹{order.total_amount?.toFixed(2) || '0.00'}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<Visibility />}
                            onClick={() => handleOpenDialog(order)}
                            sx={{
                              bgcolor: '#006D77',
                              textTransform: 'none',
                              fontSize: '0.75rem',
                              '&:hover': { bgcolor: '#005560' }
                            }}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
           <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
    <Pagination count={totalPages} page={page} onChange={(e, v) => fetchOrders(v, searchQuery)} color="primary" />
</Stack>
          </Paper>
        )}
      </Container>

      <Dialog 
  open={dialogOpen} 
  onClose={handleCloseDialog} 
  maxWidth="lg" 
  fullWidth 
  scroll="paper"
  PaperProps={{
    sx: {
      maxHeight: '90vh',
      borderRadius: 3
    }
  }}
>
  {selectedOrder && (
    <>
      <DialogTitle 
        sx={{ 
          bgcolor: '#006D77', 
          color: 'white', 
          display: 'flex', 
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
          px: 3
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
          {/* Back Button */}
          {orderHistory.length > 0 && (
            <IconButton 
              onClick={handleGoBack}
              sx={{ 
                color: 'white',
                bgcolor: 'rgba(255,255,255,0.1)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          
          {/* Order Info */}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <Typography variant="h5" fontWeight="bold">
                {selectedOrder.order_id}
              </Typography>
              {selectedOrder.is_child && (
                <Chip 
                  label="Split Order" 
                  size="small"
                  sx={{ 
                    bgcolor: '#F59E0B', 
                    color: 'white',
                    fontWeight: 600,
                    height: 24
                  }} 
                />
              )}
              {selectedOrder.is_parent && selectedOrder.has_children && (
                <Chip 
                  label={`${selectedOrder.child_order_count} Splits`}
                  size="small"
                  icon={<CallSplitIcon sx={{ color: 'white !important' }} />}
                  sx={{ 
                    bgcolor: 'rgba(255,255,255,0.2)', 
                    color: 'white',
                    fontWeight: 600,
                    height: 24
                  }} 
                />
              )}
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Chip 
                icon={getStatusConfig(selectedOrder.order_status).icon} 
                label={statusLabelMap[selectedOrder.order_status] || getStatusConfig(selectedOrder.order_status).label}
                color={getStatusConfig(selectedOrder.order_status).color}
                size="small"
                sx={{ 
                  bgcolor: 'rgba(17, 1, 1, 0.9)', 
                  color:"white",
                  fontWeight: 600,
                }} 
              />
              <PaymentPendingChip order={selectedOrder} apiFetch={apiRequest} notify={showCustomDialog} />
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {formatDate(selectedOrder.created_at)}
              </Typography>
            </Box>
          </Box>
        </Box>
        
        <IconButton onClick={handleCloseDialog} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ bgcolor: '#F9FAFB', p: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          
          {/* Split Orders Navigation Card - Show ONLY for parent orders */}
          {selectedOrder.is_parent && selectedOrder.has_children && getCurrentChildOrders().length > 0 && (
            <Paper 
              elevation={3}
              sx={{ 
                p: 3, 
                background: 'linear-gradient(135deg, #006D77 0%, #005560 100%)',
                color: 'white',
                borderRadius: 2
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <CallSplitIcon sx={{ fontSize: 28 }} />
                <Typography variant="h6" fontWeight="bold">
                  Split Orders ({getCurrentChildOrders().length})
                </Typography>
              </Box>
              
              <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
                This order has been split into multiple deliveries. Click on any split order to view details.
              </Typography>
              
              <Grid container spacing={2}>
                {getCurrentChildOrders().map((childOrder, index) => (
                  <Grid item xs={12} sm={6} md={4} key={childOrder.order_id}>
                    <Card
                      sx={{
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        bgcolor: 'rgba(255,255,255,0.95)',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: 6,
                          bgcolor: 'white'
                        }
                      }}
                      onClick={() => handleNavigateToChildOrder(childOrder)}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1.5 }}>
                          <Box>
                            <Typography variant="subtitle2" fontWeight="bold" color="#006D77" gutterBottom>
                              {childOrder.order_id}
                            </Typography>
                            <Chip 
                              label={statusLabelMap[childOrder.order_status] || getStatusConfig(childOrder.order_status).label}
                              color={getStatusConfig(childOrder.order_status).color}
                              size="small"
                              sx={{ height: 20, fontSize: '0.7rem' }}
                            />
                          </Box>
                          <IconButton 
                            size="small"
                            sx={{ 
                              color: '#006D77',
                              bgcolor: '#F0F9FF',
                              '&:hover': { bgcolor: '#E0F2F1' }
                            }}
                          >
                            <ArrowForwardIcon fontSize="small" />
                          </IconButton>
                        </Box>
                        
                        <Divider sx={{ my: 1 }} />
                        
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography variant="caption" color="text.secondary">
                            {childOrder.items?.length || 0} items
                          </Typography>
                          <Typography variant="body1" fontWeight="bold" color="#006D77">
                            ₹{childOrder.total_amount?.toFixed(2)}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          )}

          {/* Parent Order Reference - Show ONLY for child orders */}
          {selectedOrder.is_child && selectedOrder.parent_order_id && (
            <Alert 
              severity="info" 
              icon={<CallSplitIcon />}
              sx={{ borderRadius: 2 }}
            >
              <Typography variant="body2" fontWeight="600">
                This is a split order from parent order: {selectedOrder.parent_order_id}
              </Typography>
              <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                Use the back button to return to the parent order
              </Typography>
            </Alert>
          )}

          {/* Prescription Section */}
          {(hasPrescription(selectedOrder) || loadingPrescriptions[selectedOrder.order_id]) && (
            <Paper variant="outlined" sx={{ p: 2, bgcolor: '#F0F9FF', borderColor: '#006D77' }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DescriptionIcon sx={{ color: '#006D77' }} />
                Prescription Files
              </Typography>
              <Divider sx={{ my: 2 }} />
              
              {loadingPrescriptions[selectedOrder.order_id] ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress size={40} sx={{ color: '#006D77' }} />
                </Box>
              ) : (
                <Grid container spacing={2}>
                  {getPrescriptionUrls(selectedOrder).map((url, index) => {
                    const fileType = getFileType(url);
                    const fullUrl = buildPrescriptionUrl(url);
                    const isS3File = url.includes('cloudfront.net') || url.includes('amazonaws.com');

                    return (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Paper elevation={2} sx={{ p: 1.5, '&:hover': { transform: 'scale(1.05)', boxShadow: 4 } }}>
                          {fileType === 'image' ? (
                            <Box
                              component="img"
                              src={fullUrl}
                              alt={`Prescription ${index + 1}`}
                              sx={{ 
                                width: '100%', 
                                height: 150, 
                                objectFit: 'cover', 
                                borderRadius: 1, 
                                mb: 1, 
                                cursor: 'pointer'
                              }}
                              onClick={() => handleViewPrescription(url)}
                              onError={(e) => {
                                console.error('Image failed to load:', fullUrl);
                                e.target.src = 'https://via.placeholder.com/150x150?text=Image+Not+Found';
                              }}
                            />
                          ) : (
                            <Box
                              sx={{ 
                                width: '100%', 
                                height: 150, 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                bgcolor: '#F5F5F5', 
                                borderRadius: 1, 
                                mb: 1, 
                                cursor: 'pointer' 
                              }}
                              onClick={() =>
                                isS3File
                                  ? window.open(fullUrl, '_blank')
                                  : handleDownloadPrescription(selectedOrder.order_id, url)
                              }
                            >
                              <DescriptionIcon sx={{ fontSize: 60, color: '#006D77' }} />
                            </Box>
                          )}
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => {
                                if (fileType === 'image') {
                                  handleViewPrescription(url);
                                } else if (fileType === 'pdf') {
                                  const fullUrl = buildPrescriptionUrl(url);
                                  setSelectedPrescriptionUrl(fullUrl);
                                  setPrescriptionType('pdf');
                                  setPrescriptionViewerOpen(true);
                                } else {
                                  handleDownloadPrescription(selectedOrder.order_id, url);
                                }
                              }}
                              fullWidth
                              sx={{ bgcolor: '#006D77', '&:hover': { bgcolor: '#005560' }, textTransform: 'none', fontSize: '11px' }}
                            >
                              {fileType === 'image' ? 'View' : fileType === 'pdf' ? 'View PDF' : 'Open'}
                            </Button>
                            <IconButton
                              size="small"
                              onClick={() => handleDownloadPrescription(selectedOrder.order_id, url)}
                              sx={{ bgcolor: '#E0E0E0', '&:hover': { bgcolor: '#BDBDBD' } }}
                            >
                              <DownloadIcon fontSize="small" />
                            </IconButton>
                          </Box>
                          <Typography variant="caption" sx={{ display: 'block', mt: 1, textAlign: 'center', color: 'text.secondary' }}>
                            Prescription {index + 1}
                          </Typography>
                        </Paper>
                      </Grid>
                    );
                  })}
                </Grid>
              )}
            </Paper>
          )}
          {/* User Information */}
          <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1,color: '#006D77' }}>
              {selectedOrder.order_from}
            </Typography>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <UserIcon sx={{ color: '#006D77' }} />
              User Information
            </Typography>
            <List dense>
              <ListItem>
                <ListItemIcon><UserIcon /></ListItemIcon>
                <ListItemText primary={selectedOrder.delivery_address.full_name} />
              </ListItem>
              <ListItem>
                <ListItemIcon><PhoneIcon /></ListItemIcon>
                <ListItemText primary={selectedOrder.user_phone} />
              </ListItem>
              <ListItem>
                <ListItemIcon><CalendarIcon /></ListItemIcon>
                <ListItemText primary={formatDate(selectedOrder.created_at)} />
              </ListItem>
            </List>
          </Paper>

                {/* ─── Patient Information — EDITABLE ─────────────────────────────────── */}
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonIcon sx={{ color: '#006D77' }} />Patient Information
                    </Typography>
                    {!editingPatient ? (
                      <Button
                        size="small"
                        variant="outlined"
                        startIcon={<EditIcon />}
                        onClick={handleStartEditPatient}
                        sx={{ textTransform: 'none', borderColor: '#006D77', color: '#006D77', '&:hover': { bgcolor: '#E0F2F1', borderColor: '#005560' } }}
                      >
                        Edit
                      </Button>
                    ) : (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<CancelIcon />}
                          onClick={handleCancelEditPatient}
                          disabled={savingPatient}
                          sx={{ textTransform: 'none', borderColor: '#9E9E9E', color: '#616161' }}
                        >
                          Cancel
                        </Button>
                        <Button
                          size="small"
                          variant="contained"
                          startIcon={savingPatient ? <CircularProgress size={14} color="inherit" /> : <SaveIcon />}
                          onClick={handleSavePatient}
                          disabled={savingPatient}
                          sx={{ textTransform: 'none', bgcolor: '#006D77', '&:hover': { bgcolor: '#005560' } }}
                        >
                          {savingPatient ? 'Saving…' : 'Save'}
                        </Button>
                      </Box>
                    )}
                  </Box>

                  {!editingPatient ? (
                    /* READ VIEW */
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, pl: 1 }}>
                      {selectedOrder.patient_details?.name && <Typography><strong>Name:</strong> {selectedOrder.patient_details.name}</Typography>}
                      {selectedOrder.patient_details?.age && <Typography><strong>Age:</strong> {selectedOrder.patient_details.age}</Typography>}
                      {selectedOrder.patient_details?.gender && <Typography><strong>Gender:</strong> {selectedOrder.patient_details.gender}</Typography>}
                      {selectedOrder.patient_details?.phone && <Typography><strong>Phone:</strong> {selectedOrder.patient_details.phone}</Typography>}
                      {selectedOrder.patient_details?.doctorname && <Typography><strong>Doctor:</strong> {selectedOrder.patient_details.doctorname}</Typography>}
                      {!selectedOrder.patient_details?.name && !selectedOrder.patient_details?.age && (
                        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>No patient details recorded.</Typography>
                      )}
                    </Box>
                  ) : (
                    /* EDIT VIEW */
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Patient Name"
                          fullWidth
                          size="small"
                          value={patientForm.name}
                          onChange={e => setPatientForm(f => ({ ...f, name: e.target.value }))}
                          sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#006D77' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#006D77' } }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          label="Age"
                          fullWidth
                          size="small"
                          type="number"
                          inputProps={{ min: 0, max: 150 }}
                          value={patientForm.age}
                          onChange={e => setPatientForm(f => ({ ...f, age: e.target.value }))}
                          sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#006D77' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#006D77' } }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <FormControl fullWidth size="small">
                          <InputLabel sx={{ '&.Mui-focused': { color: '#006D77' } }}>Gender</InputLabel>
                          <Select
                            label="Gender"
                            value={patientForm.gender}
                            onChange={e => setPatientForm(f => ({ ...f, gender: e.target.value }))}
                            sx={{ '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#006D77' } }}
                          >
                            <MenuItem value="">Not specified</MenuItem>
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Patient Phone"
                          fullWidth
                          size="small"
                          value={patientForm.phone}
                          onChange={e => { // Allow only digits
                         let phoneValue = e.target.value;
                          // Allow only digits and +
                          phoneValue = phoneValue.replace(/[^\d+]/g, "");

                          setPatientForm((f) => ({ ...f, phone: phoneValue }));

                          // Validation
                          let error = "";

                          // Remove + for validation
                          const numeric = phoneValue.replace(/^\+/, "");

                          // Case 1: Indian number with country code (91 + 10 digits)
                          if (numeric.startsWith("91")) {
                            if (!/^91[6-9]\d{9}$/.test(numeric)) {
                              error = "Enter valid Indian number with +91";
                            }
                          } 
                          // Case 2: Without country code (10 digits)
                          else {
                            if (numeric && !/^[6-9]\d{9}$/.test(numeric)) {
                              error = "Enter valid 10-digit mobile number";
                            }
                          }
                            setErrors((prev) => ({ ...prev, phone: error }));
                          }
                        }
                        error={!!errors.phone}
                        helperText={errors.phone}
                        inputProps={{ maxLength: 13 }}
                          sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#006D77' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#006D77' } }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Doctor Name"
                          fullWidth
                          size="small"
                          value={patientForm.doctorname}
                          onChange={e => setPatientForm(f => ({ ...f, doctorname: e.target.value }))}
                          sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#006D77' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#006D77' } }}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Paper>
                {/* ─────────────────────────────────────────────────────────────────────── */}

          {/* Delivery Address */}
          {selectedOrder.delivery_address && (
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <MapPinIcon sx={{ color: '#006D77' }} />
                Delivery Address
              </Typography>
              <Box>
                <Typography variant="body2" fontWeight="bold">{selectedOrder.delivery_address.full_name}</Typography>
                <Typography variant="body2" fontWeight="bold">Community Name: {selectedOrder.delivery_address.community_name}</Typography>
                <Typography variant="body2">Block: {selectedOrder.delivery_address.address_line1}</Typography>
                {selectedOrder.delivery_address.address_line2 && (
                  <Typography variant="body2">Flat No: {selectedOrder.delivery_address.address_line2}</Typography>
                )}
                <Typography variant="body2" color="text.secondary">Phone: {selectedOrder.delivery_address.phone}</Typography>
                <Typography variant="body2" color="text.secondary">Delivery Time Option: {selectedOrder.delivery_address.delivery_time_option}</Typography>
                <Typography variant="body2" color="text.secondary">Delivery Time: {selectedOrder.delivery_address.delivery_time}</Typography>
              </Box>
            </Paper>
          )}



{/* Order Pricing Summary */}
{selectedOrder.order_pricing && (
  <Paper variant="outlined" sx={{ p: 4, mt: 3, border: "1px solid #e0e0e0", borderRadius: 2 }}>
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
      <Typography variant="h6" sx={{ color: "#263238", fontWeight: 700, letterSpacing: "-0.5px" }}>
      Order Pricing Summary
      </Typography>
      <Chip 
        label={`Alpha: ${selectedOrder.order_pricing.alpha ?? 0}`} 
        variant="outlined" 
        size="small" 
        sx={{ borderRadius: 1, fontWeight: 'bold' }} 
      />
    </Box>

    <Grid container spacing={6}>
      {/* Left Column: Revenue & Costs */}
      <Grid item xs={12} md={7}>
        <TableContainer component={Box}>
          <Table size="small">
            <TableBody>
              {[
                { label: "Total MRP", value: selectedOrder.order_pricing.totalMRP, type: 'currency' },
                { label: "Total Base Price", value: selectedOrder.order_pricing.totalBP, type: 'currency' },
                { label: "Total Discount Value", value: selectedOrder.order_pricing.totalDiscountValue, type: 'currency', color: 'error.main' },
                { label: "Max Discount Amount", value: selectedOrder.order_pricing.orderMaxDiscountAmount, type: 'currency' },
              ].map((row) => (
                <TableRow key={row.label} sx={{ '& td': { borderBottom: '1px solid #f5f5f5', py: 1.5, px: 0 } }}>
                  <TableCell sx={{ color: 'text.secondary', fontWeight: 500 }}>{row.label}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600, color: row.color || 'inherit' }}>
                    {row.type === 'currency' ? `₹${(row.value ?? 0).toLocaleString()}` : row.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {/* Right Column: Performance & Margin Indicators */}
      <Grid item xs={12} md={5}>
        <Box sx={{ bgcolor: "#F8FAFC", p: 3, borderRadius: 2, height: '100%' }}>
          <Stack spacing={2.5}>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">Final Selling Price</Typography>
              <Typography variant="body1" fontWeight="700" color="success.main">
              ₹{(selectedOrder.order_pricing.totalSellingRevenue ?? 0).toLocaleString()}
              </Typography>
            </Box>
            
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">Total Profit</Typography>
              <Typography variant="body1" fontWeight="700" color="#006D77">
              ₹{(selectedOrder.order_pricing.totalProfitValue ?? 0).toLocaleString()}
              </Typography>
            </Box>

            <Divider />
            <Box>
              <Typography variant="caption" display="block" color="text.secondary" gutterBottom>
                PROFIT MARGIN ON BP
              </Typography>
              <Typography variant="h4" sx={{ color: "#006D77", fontWeight: 800 }}>
                {selectedOrder.order_pricing.finalProfitPercentOnBP ?? 0}%
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Grid>
    </Grid>

    {/* Footer: Discount Logic */}
    <Box sx={{ mt: 4, pt: 3, borderTop: "1px dashed #e0e0e0" }}>
       <Grid container spacing={4}>
          {[
            { label: "Allowed Disc. %", value: selectedOrder.order_pricing.finalAllowedDiscountPercent },
            { label: "Profit Protected %", value: selectedOrder.order_pricing.profitProtectedMaxDiscountPercent },
            { label: "Actual Max Disc. %", value: selectedOrder.order_pricing.orderMaxDiscountPercent },
          ].map((item) => (
            <Grid item xs={4} key={item.label}>
               <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', fontWeight: 600 }}>
                 {item.label}
               </Typography>
               <Typography variant="body1" fontWeight="600">
                 {item.value ?? 0}%
               </Typography>
            </Grid>
          ))}
       </Grid>
    </Box>
  </Paper>
)}







{/* Medicines Ordered - WITH GST DETAILS */}
{selectedOrder.items && selectedOrder.items.length > 0 && (
  <Paper variant="outlined" sx={{ p: 2 }}>
    <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <PillIcon sx={{ color: '#006D77' }} />
      Medicines Ordered
    </Typography>
    
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: '#F0F9FF' }}>
            <TableCell><strong>#</strong></TableCell>
            <TableCell><strong>Medicine Name</strong></TableCell>
            <TableCell align="center"><strong>Qty</strong></TableCell>
            <TableCell align="right"><strong>MRP</strong></TableCell>
            <TableCell align="right"><strong>Base Price</strong></TableCell>
            <TableCell align="right"><strong>Selling Price</strong></TableCell>
            <TableCell align="right"><strong>Discount%</strong></TableCell>
            <TableCell align="right"><strong>GST%</strong></TableCell>
            <TableCell align="right"><strong>Discount Amt</strong></TableCell>
            <TableCell align="right"><strong>Profit</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedOrder.items.map((item, idx) => {
            const itemGST = calculateItemGST(item);
                                        console.log(selectedOrder)

            return (
              <React.Fragment key={idx}>
                <TableRow>
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight="600">
                      {item.medicine_name}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip 
                      label={item.quantity} 
                      size="small" 
                      color="primary"
                      sx={{ fontWeight: 'bold' }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    ₹{(item.price || item.price)?.toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                    ₹{itemGST.basePrice.toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                  ₹{(item.total_price)?.toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                  {(item.applied_discount_pct)?.toFixed(2)}%
                  </TableCell>
                  
                  <TableCell align="right">
                    <Chip 
                      label={`${itemGST.gstRate}%`}
                      size="small"
                      sx={{ bgcolor: '#E3F2FD', color: '#1976D2', fontWeight: 'bold' }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    ₹{item.discount_value.toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                      ₹{item.profit_value?.toFixed(2)}
                  </TableCell>
                </TableRow>
                
                {/* GST Breakdown Row */}
                <TableRow>
                  <TableCell colSpan={8} sx={{ py: 1, bgcolor: '#FAFAFA', borderBottom: idx === selectedOrder.items.length - 1 ? '2px solid #E0E0E0' : '1px solid #F0F0F0' }}>
                    <Typography variant="caption" color="text.secondary">
                      {itemGST.igst > 0 ? (
                        <>IGST @ {itemGST.igst}%: ₹{itemGST.igstAmount.toFixed(2)}</>
                      ) : (
                        <>
                          CGST @ {itemGST.cgst}%: ₹{itemGST.cgstAmount.toFixed(2)} | 
                          SGST @ {itemGST.sgst}%: ₹{itemGST.sgstAmount.toFixed(2)}
                        </>
                      )}
                      {' | '}Base: ₹{(itemGST.basePrice / item.quantity).toFixed(2)}/unit × {item.quantity} = ₹{itemGST.basePrice.toFixed(2)} + GST ₹{itemGST.gstAmount.toFixed(2)} = ₹{itemGST.totalPrice.toFixed(2)}
                    </Typography>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
    {selectedOrder.return_items_history?.length > 0 && (
  <Paper
    variant="outlined"
    sx={{
      p: 3,
      mt: 3,
      border: "1px solid #FFCDD2",
      bgcolor: "#FFF8F8"
    }}
  >
    <Typography
      variant="h6"
      fontWeight="bold"
      gutterBottom
      color="error.main"
    >
      Returned Medicines
    </Typography>

    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>Medicine</strong></TableCell>
            <TableCell align="center"><strong>Qty Returned</strong></TableCell>
            <TableCell align="right"><strong>Refund Amount</strong></TableCell>
            <TableCell><strong>Reason</strong></TableCell>
            <TableCell><strong>Date</strong></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {selectedOrder.return_items_history.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.medicine_name}</TableCell>

              <TableCell align="center">
                {item.quantity}
              </TableCell>

              <TableCell align="right">
                ₹{Number(item.refunded_amount || 0).toFixed(2)}
              </TableCell>

              <TableCell>
                {item.return_reason || "-"}
              </TableCell>

              <TableCell>
                {item.returned_at
                  ? new Date(item.returned_at).toLocaleString()
                  : "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <Box
      sx={{
        mt: 2,
        display: "flex",
        justifyContent: "flex-end"
      }}
    >
      <Typography
        variant="h6"
        color="error.main"
        fontWeight="bold"
      >
        Total Refunded: ₹
        {Number(selectedOrder.payment.total_refunded_amount || 0).toFixed(2)}
      </Typography>
    </Box>
  </Paper>
)}
    
    {/* GST Summary */}
    {(() => {
      const orderGST = calculateOrderGST(selectedOrder.items);
      return (
        <Box sx={{ mt: 2, p: 2, bgcolor: '#F0F9FF', borderRadius: 1 }}>
          <Typography variant="subtitle2" fontWeight="bold" color="#006D77" gutterBottom>
            GST Summary
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <Typography variant="caption" color="text.secondary">Base Amount</Typography>
              <Typography variant="body1" fontWeight="bold">₹{orderGST.basePrice.toFixed(2)}</Typography>
            </Grid>
            {orderGST.cgst > 0 && (
              <Grid item xs={6} sm={3}>
                <Typography variant="caption" color="text.secondary">CGST</Typography>
                <Typography variant="body1" fontWeight="bold">₹{orderGST.cgst.toFixed(2)}</Typography>
              </Grid>
            )}
            {orderGST.sgst > 0 && (
              <Grid item xs={6} sm={3}>
                <Typography variant="caption" color="text.secondary">SGST</Typography>
                <Typography variant="body1" fontWeight="bold">₹{orderGST.sgst.toFixed(2)}</Typography>
              </Grid>
            )}
            {orderGST.igst > 0 && (
              <Grid item xs={6} sm={3}>
                <Typography variant="caption" color="text.secondary">IGST</Typography>
                <Typography variant="body1" fontWeight="bold">₹{orderGST.igst.toFixed(2)}</Typography>
              </Grid>
            )}
            <Grid item xs={6} sm={3}>
              <Typography variant="caption" color="text.secondary">Total GST</Typography>
              <Typography variant="body1" fontWeight="bold" color="#1976D2">₹{orderGST.totalGST.toFixed(2)}</Typography>
            </Grid>
          </Grid>
        </Box>
      );
    })()}
  </Paper>
)}


          {/* Agent Details */}
          {selectedOrder?.assigned_agent_id && (
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonIcon sx={{ color: '#006D77' }} />
                Assigned Delivery Agent
              </Typography>
              {loadingAgent ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                  <CircularProgress size={40} sx={{ color: '#006D77' }} />
                </Box>
              ) : agentDetails ? (
                <TableContainer>
                  <Table size="small">
                    <TableBody>
                      <TableRow>
                        <TableCell><strong>Agent ID</strong></TableCell>
                        <TableCell>{agentDetails.agentId}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell><strong>Name</strong></TableCell>
                        <TableCell>{agentDetails.name}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell><strong>Phone</strong></TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Phone sx={{ fontSize: 18, color: '#006D77' }} />
                            {agentDetails.phone}
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell><strong>Email</strong></TableCell>
                        <TableCell>{agentDetails.email}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Box sx={{ p: 2, bgcolor: '#FEF3C7', borderRadius: 2, textAlign: 'center' }}>
                  <Typography sx={{ color: '#D97706' }}> Agent details not available</Typography>
                </Box>
              )}
            </Paper>
          )}


{selectedOrder?.delivery_issues && selectedOrder.delivery_issues.length > 0 && (

  <Paper variant="outlined" sx={{ p: 2 }}>
    {/* Header Section */}
    <Box 
      sx={{ p: 2.5, color: 'blqack',display: 'flex',justifyContent: 'space-between',alignItems: 'center',cursor: 'pointer'}}
      onClick={() => {
        // Toggle all issues expansion state
        const allIssueIds = selectedOrder.delivery_issues.map(i => i.issue_id);
        const allExpanded = allIssueIds.every(id => expandedIssues[id]);
        const newExpandedState = {};
        allIssueIds.forEach(id => {
          newExpandedState[id] = !allExpanded;
        });
        setExpandedIssues(newExpandedState);
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box  sx={{ width: 48, height: 48, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.2)',display: 'flex',alignItems: 'center',justifyContent: 'center' }} >
          <AlertCircleIcon sx={{ fontSize: 28 }} />
        </Box>
        <Box>
          <Typography variant="h6" fontWeight="bold">
            Delivery Issues
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            {/* {selectedOrder.delivery_issues.filter(i => i.status === 'open').length} Active • 
            {' '}{selectedOrder.delivery_issues.filter(i => i.status === 'resolved').length} Resolved •  */}
            {' '}{selectedOrder.delivery_issues.length} Total
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Chip 
          label={`${selectedOrder.delivery_issues.length} Issue${selectedOrder.delivery_issues.length > 1 ? 's' : ''}`}
          sx={{ bgcolor: '#006D77', color: 'white',fontWeight: 700,fontSize: '0.875rem'}}
        />
      </Box>
    </Box>

    {/* Issues List */}
    <Box sx={{ bgcolor: '#FEFEFE' }}>
      {selectedOrder.delivery_issues.map((issue, index) => {
        const isExpanded = expandedIssues[issue.issue_id] || false;
        const issueTypeFormatted = issue.issue_type?.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase()) || 'N/A';
        
        return (
          <Box 
            key={issue.issue_id || index}
            sx={{  borderBottom: index < selectedOrder.delivery_issues.length - 1 ? '1px solid #E5E7EB' : 'none'}}
          >
            {/* Collapsible Header */}
            <Box
              onClick={() => setExpandedIssues(prev => ({ ...prev, [issue.issue_id]: !isExpanded }))}
              sx={{p: 2,display: 'flex',justifyContent: 'space-between',alignItems: 'center',cursor: 'pointer',}}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                {/* Status Indicator */}
                <Box
                  sx={{width: 8,height: 8,borderRadius: '50%',bgcolor:  '#006D77',boxShadow: `0 0 0 3px ${'#D1EEF0'}`}}
                />
                
                {/* Issue Info */}
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
                    <Typography variant="body1" fontWeight="700" color="#1F2937">
                      {issue.issue_id}
                    </Typography>
                    <Chip 
                      label={issueTypeFormatted}
                      size="small"
                      sx={{ bgcolor: '#D1EEF0',fontWeight: 600,fontSize: '0.75rem',height: 22}}
                    />
                    <Chip 
                      label={issue.status === 'resolved' ? 'Resolved' : issue.status === 'in_progress' ? 'In Progress' : 'Open'}
                      size="small"
                      color={issue.status === 'resolved' ? 'success' :issue.status === 'in_progress' ? 'warning' :'error'}
                      sx={{ fontWeight: 600,fontSize: '0.75rem',height: 22}}
                    />
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    Reported {formatDate(issue.reported_at)} • By {issue.reported_by || 'Unknown'}
                  </Typography>
                </Box>
              </Box>

              {/* Expand Icon */}
              <IconButton 
                size="small"
                sx={{ color: '#6B7280',transition: 'transform 0.2s',transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}}
              >
                <ExpandMoreIcon />
              </IconButton>
            </Box>

            {/* Expandable Content */}
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <Box sx={{ p: 3, bgcolor: '#F9FAFB', borderTop: '1px solid #E5E7EB' }}>
                <Grid container spacing={3}>
                  {/* Description */}
                  <Grid item xs={12}>
                    <Box>
                      <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>
                        Issue Description
                      </Typography>
                      <Paper 
                        variant="outlined"
                        sx={{ p: 2, bgcolor: 'white',borderColor: '#E5E7EB'}}
                      >
                        <Typography variant="body2" color="#4B5563" sx={{ lineHeight: 1.6 }}>
                          {issue.description || 'No description provided'}
                        </Typography>
                      </Paper>
                    </Box>
                  </Grid>

                  {/* Photo Evidence */}
                  {issue.photo_url && (
                    <Grid item xs={12} md={6}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>
                          Photo Evidence
                        </Typography>
                        <Paper
                          elevation={2}
                          sx={{position: 'relative',overflow: 'hidden',borderRadius: 2,cursor: 'pointer',transition: 'all 0.3s', '&:hover': { transform: 'scale(1.02)',}
                          }}
                          onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`, '_blank')}
                        >
                          <Box
                            component="img"
                            src={`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`}
                            alt="Issue evidence"
                            sx={{width: '100%',height: 250,objectFit: 'cover'}}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                          <Box
                            sx={{position: 'absolute',bottom: 0,left: 0,right: 0,bgcolor: 'rgba(0,0,0,0.6)',color: 'white',p: 1,display: 'flex',alignItems: 'center',justifyContent: 'center',gap: 0.5 }}
                          >
                            <Typography variant="caption" fontWeight="600">
                              Click to view full size
                            </Typography>
                          </Box>
                        </Paper>
                      </Box>
                    </Grid>
                  )}

                  {/* Issue Details */}
                  <Grid item xs={12} md={issue.photo_url ? 6 : 12}>
                    <Box>
                      <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>
                        Issue Details
                      </Typography>
                      <Paper variant="outlined" sx={{ bgcolor: 'white', borderColor: '#E5E7EB' }}>
                        <List dense disablePadding>
                          <ListItem divider>
                            <ListItemText 
                              primary={<Typography variant="caption" color="text.secondary">Issue ID</Typography>}
                              secondary={<Typography variant="body2" fontWeight="600">{issue.issue_id}</Typography>}
                            />
                          </ListItem>
                          <ListItem divider>
                            <ListItemText 
                              primary={<Typography variant="caption" color="text.secondary">Type</Typography>}
                              secondary={<Typography variant="body2" fontWeight="600">{issueTypeFormatted}</Typography>}
                            />
                          </ListItem>
                          <ListItem divider>
                            <ListItemText 
                              primary={<Typography variant="caption" color="text.secondary">Status</Typography>}
                              secondary={
                                <Chip 
                                  label={issue.status === 'resolved' ? 'Resolved' : issue.status === 'in_progress' ? 'In Progress' : 'Open'}
                                  size="small"
                                  color={issue.status === 'resolved' ? 'success' :issue.status === 'in_progress' ? 'warning' :'error' }
                                  sx={{ mt: 0.5, fontWeight: 600 }}
                                />
                              }
                            />
                          </ListItem>
                          <ListItem divider>
                            <ListItemText 
                              primary={<Typography variant="caption" color="text.secondary">Reported By</Typography>}
                              secondary={<Typography variant="body2" fontWeight="600">{issue.reported_by || 'Unknown'}</Typography>}
                            />
                          </ListItem>
                          <ListItem>
                            <ListItemText 
                              primary={<Typography variant="caption" color="text.secondary">Reported At</Typography>}
                              secondary={<Typography variant="body2" fontWeight="600">{formatDate(issue.reported_at)}</Typography>}
                            />
                          </ListItem>
                        </List>
                      </Paper>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Collapse>
          </Box>
        );
      })}
    </Box>

    {/* Footer Summary */}
    <Box sx={{ p: 2, bgcolor: '#F9FAFB',borderTop: '2px solid #E5E7EB',display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
      <Typography variant="body2" color="text.secondary" fontWeight="500">
        Total Issues: {selectedOrder.delivery_issues.length}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <Chip 
          icon={<AlertCircleIcon sx={{ fontSize: 16 }} />}
          label={`${selectedOrder.delivery_issues.filter(i => i.status === 'open').length} Open`}
          size="small"
          sx={{ bgcolor: '#FEE2E2',color: '#991B1B',fontWeight: 600}}
        />
      </Box>
    </Box>
  </Paper>
)}



{/* Invoice Summary Section - WITH GST & COUPON DETAILS */}
{selectedOrder.items && selectedOrder.items.length > 0 && (
  <Paper variant="outlined" sx={{ p: 3 }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DescriptionIcon sx={{ color: '#4CAF50' }} />
        Invoice Summary
      </Typography>
      <Button
        variant="contained"
        size="small"
        startIcon={<DownloadIcon />}
        onClick={() => {
          handleInvoiceDownload(selectedOrder.order_id)
        }}
        sx={{ 
          bgcolor: '#006D77', 
          '&:hover': { bgcolor: '#005560' },
          textTransform: 'none'
        }}
      >
        Download Invoice
      </Button>
    </Box>
    
    <Divider sx={{ my: 2 }} />
    
    {/* Invoice Header */}
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={6}>
        <Typography variant="body2" color="text.secondary">Invoice Number:</Typography>
        <Typography variant="body1" fontWeight="bold">{selectedOrder.order_id}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2" color="text.secondary">Invoice Date:</Typography>
        <Typography variant="body1" fontWeight="bold">{formatDate(selectedOrder.created_at)}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2" color="text.secondary">Customer Name:</Typography>
        <Typography variant="body1" fontWeight="bold">{selectedOrder.delivery_address?.full_name}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2" color="text.secondary">Phone:</Typography>
        <Typography variant="body1" fontWeight="bold">{selectedOrder.user_phone}</Typography>
      </Grid>
    </Grid>
    
    <Divider sx={{ my: 2 }} />
    
    {/* Pricing Breakdown */}
    {(() => {
      const orderGST = calculateOrderGST(selectedOrder.items);
      const subtotal = selectedOrder.subtotal || selectedOrder.items.reduce((sum, item) => sum + (item.total_price || 0), 0);
      
      return (
        <Box sx={{ mb: 2 }}>
          <TableContainer>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none', py: 1 }}>
                    <Typography variant="body2">Base Amount (Before GST):</Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ borderBottom: 'none', py: 1 }}>
                    <Typography variant="body2" fontWeight="600">₹{orderGST.basePrice.toFixed(2)}</Typography>
                  </TableCell>
                </TableRow>
                
                {orderGST.cgst > 0 && (
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', py: 0.5, pl: 4 }}>
                      <Typography variant="caption" color="text.secondary">CGST:</Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none', py: 0.5 }}>
                      <Typography variant="caption">₹{orderGST.cgst.toFixed(2)}</Typography>
                    </TableCell>
                  </TableRow>
                )}
                
                {orderGST.sgst > 0 && (
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', py: 0.5, pl: 4 }}>
                      <Typography variant="caption" color="text.secondary">SGST:</Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none', py: 0.5 }}>
                      <Typography variant="caption">₹{orderGST.sgst.toFixed(2)}</Typography>
                    </TableCell>
                  </TableRow>
                )}
                
                {orderGST.igst > 0 && (
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', py: 0.5, pl: 4 }}>
                      <Typography variant="caption" color="text.secondary">IGST:</Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none', py: 0.5 }}>
                      <Typography variant="caption">₹{orderGST.igst.toFixed(2)}</Typography>
                    </TableCell>
                  </TableRow>
                )}
                
                <TableRow>
                  <TableCell sx={{ borderTop: '1px solid #E0E0E0', py: 1 }}>
                    <Typography variant="body2" fontWeight="600">Total GST:</Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ borderTop: '1px solid #E0E0E0', py: 1 }}>
                    <Typography variant="body2" fontWeight="600" color="#1976D2">₹{orderGST.totalGST.toFixed(2)}</Typography>
                  </TableCell>
                </TableRow>
                
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none', py: 1 }}>
                    <Typography variant="body2" fontWeight="600">Subtotal (incl. GST):</Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ borderBottom: 'none', py: 1 }}>
                    <Typography variant="body2" fontWeight="600">₹{subtotal.toFixed(2)}</Typography>
                  </TableCell>
                </TableRow>
                {selectedOrder.return_items_history.length>0 &&<TableRow>
                  <TableCell sx={{ borderBottom: 'none', py: 1 }}>
                    <Typography variant="body2" color="error.main" fontWeight="600">Refund (incl. GST):</Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ borderBottom: 'none', py: 1 }}>
                    <Typography variant="body2" color="error.main" fontWeight="600">₹{selectedOrder.payment.total_refunded_amount.toFixed(2)}</Typography>
                  </TableCell>
                </TableRow>}
                {/* Subscription Discount */}
                {selectedOrder.subscription_discount > 0 && (
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', py: 1 }}>
                      <Typography variant="body2" color="success.main">Subscription Discount:</Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none', py: 1 }}>
                      <Typography variant="body2" color="success.main" fontWeight="600">- ₹{selectedOrder.subscription_discount.toFixed(2)}</Typography>
                    </TableCell>
                  </TableRow>
                )}
                
                {/* Promo Discount */}
                {selectedOrder.promo_discount > 0 && (
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', py: 1 }}>
                      <Typography variant="body2" color="success.main">
                        Promo Code {selectedOrder.promo_code ? `(${selectedOrder.promo_code})` : ''}:
                      </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none', py: 1 }}>
                      <Typography variant="body2" color="success.main" fontWeight="600">- ₹{selectedOrder.promo_discount.toFixed(2)}</Typography>
                    </TableCell>
                  </TableRow>
                )}
                
                {/* General Discount */}
                {selectedOrder.discount > 0 && (
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', py: 1 }}>
                      <Typography variant="body2" color="error.main">Discount:</Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none', py: 1 }}>
                      <Typography variant="body2" color="error.main" fontWeight="600">- ₹{selectedOrder.discount.toFixed(2)}</Typography>
                    </TableCell>
                  </TableRow>
                )}
                
                {/* Delivery Charges */}
                {selectedOrder.delivery_charge > 0 && (
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', py: 1 }}>
                      <Typography variant="body2">Delivery Charges:</Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none', py: 1 }}>
                      <Typography variant="body2" fontWeight="600">+ ₹{selectedOrder.delivery_charge.toFixed(2)}</Typography>
                    </TableCell>
                  </TableRow>
                )}
                
                <TableRow>
                  <TableCell sx={{ borderTop: '2px solid #006D77', py: 1.5 }}>
                    <Typography variant="h6" fontWeight="bold" color="#006D77">Grand Total:</Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ borderTop: '2px solid #006D77', py: 1.5 }}>
                    <Typography variant="h6" fontWeight="bold" color="#006D77">
                      ₹{(selectedOrder.total_amount-selectedOrder.payment.total_refunded_amount).toFixed(2) || '0.00'}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      );
    })()}
    
    {/* Applied Coupons/Discounts Summary */}
    {(selectedOrder.promo_code || selectedOrder.subscription_discount > 0 || selectedOrder.promo_discount > 0) && (
      <Paper sx={{ p: 2, bgcolor: '#E8F5E9', border: '1px solid #4CAF50', borderRadius: 1, mt: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" color="#2E7D32" gutterBottom>
          💰 Applied Discounts & Offers
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {selectedOrder.subscription_discount > 0 && (
            <Chip 
              label={`Subscription Benefit: ₹${selectedOrder.subscription_discount.toFixed(2)} OFF`}
              color="success"
              size="small"
              sx={{ width: 'fit-content' }}
            />
          )}
          {selectedOrder.promo_code && (
            <Chip 
              label={`Promo Code "${selectedOrder.promo_code}": ₹${selectedOrder.promo_discount.toFixed(2)} OFF`}
              color="success"
              variant="outlined"
              size="small"
              sx={{ width: 'fit-content' }}
            />
          )}
          {selectedOrder.discount > 0 && (
            <Chip 
              label={`Additional Discount: ₹${selectedOrder.discount.toFixed(2)} OFF`}
              color="error"
              variant="outlined"
              size="small"
              sx={{ width: 'fit-content' }}
            />
          )}
        </Box>
        <Typography variant="caption" color="#2E7D32" sx={{ display: 'block', mt: 1 }}>
          Total Savings: ₹{((selectedOrder.subscription_discount || 0) + (selectedOrder.promo_discount || 0) + (selectedOrder.discount || 0)).toFixed(2)}
        </Typography>
      </Paper>
    )}
    
 
        {/* Payment Status + Transaction History */}
        <Box sx={{ mt: 2, p: 2, bgcolor: 'white', borderRadius: 1, border: '1px solid #E0E0E0' }}>
          
          {/* Payment Summary Row */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="subtitle2" fontWeight="bold" color="#006D77">
              Payment Details
            </Typography>
            <Chip 
              label={selectedOrder.payment?.status || "Pending"} 
              color={
                selectedOrder.payment?.status === 'success' ? 'success' : 
                selectedOrder.payment?.status === 'refunded' ? 'info' :
                selectedOrder.payment?.status === 'failed' ? 'error' : 'warning'
              }
              size="small"
            />
          </Box>

          {/* Payment Meta Info */}
          <Grid container spacing={1} sx={{ mb: 2 }}>
            <Grid item xs={6}>
              <Typography variant="caption" color="text.secondary">Method</Typography>
              <Typography variant="body2" fontWeight="600" sx={{ textTransform: 'capitalize' }}>
                {selectedOrder.payment?.method || '—'}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" color="text.secondary">Amount</Typography>
              <Typography variant="body2" fontWeight="600" color="#006D77">
                ₹{selectedOrder.payment?.amount?.toFixed(2) || '0.00'}
              </Typography>
            </Grid>
            {selectedOrder.payment?.payment_id && (
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary">Payment ID</Typography>
                <Typography variant="body2" fontWeight="600" sx={{ 
                  fontSize: '0.75rem', 
                  wordBreak: 'break-all',
                  color: '#475569'
                }}>
                  {selectedOrder.payment.payment_id}
                </Typography>
              </Grid>
            )}
          </Grid>

          {/* Transaction History */}
          {selectedOrder.payment?.transaction_history && 
          selectedOrder.payment.transaction_history.length > 0 && (
            <>
              <Divider sx={{ my: 1.5 }} />
              <Typography variant="subtitle2" fontWeight="bold" color="#006D77" gutterBottom>
                Transaction History
              </Typography>

              <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 1 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#F0F9FF' }}>
                      <TableCell sx={{ fontWeight: 700, fontSize: '0.72rem', py: 1 }}>#</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '0.72rem', py: 1 }}>Date & Time</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '0.72rem', py: 1 }}>Method</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '0.72rem', py: 1 }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '0.72rem', py: 1 }}>Transaction ID</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedOrder.payment?.refund_transactions?.length > 0 && selectedOrder.payment.refund_transactions.map((txn, idx) => (
                      <TableRow 
                        key={idx}
                        sx={{ 
                          bgcolor: idx % 2 === 0 ? 'white' : '#FAFAFA',
                          '&:last-child td': { border: 0 }
                        }}
                      >
                        <TableCell sx={{ py: 1, fontSize: '0.75rem', color: 'text.secondary' }}>
                          {idx + 1}
                        </TableCell>
                        <TableCell sx={{ py: 1, fontSize: '0.75rem' }}>
                          {txn.created_at 
                            ? formatDate(txn.created_at) 
                            : '—'}
                        </TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Chip 
                            label={txn.refund_method || '—'} 
                            size="small" 
                            sx={{ 
                              fontSize: '0.68rem', 
                              height: 20,
                              bgcolor: txn.method === 'online' ? '#E3F2FD' : '#F3E5F5',
                              color: txn.method === 'online' ? '#1565C0' : '#6A1B9A',
                              textTransform: 'capitalize'
                            }} 
                          />
                        </TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Chip 
                            label={txn.status || '—'} 
                            size="small"
                            color={
                              txn.status === 'success' ? 'success' :
                              txn.status === 'refunded' ? 'info' :
                              txn.status === 'failed' ? 'error' : 'warning'
                            }
                            sx={{ fontSize: '0.68rem', height: 20 }}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 1, fontSize: '0.7rem', color: '#475569', maxWidth: 140 }}>
                          <Typography 
                            variant="caption" 
                            sx={{ 
                              display: 'block',
                              wordBreak: 'break-all',
                              lineHeight: 1.3
                            }}
                          >
                            {txn.payment_id || txn.gateway || '—'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                     {selectedOrder.payment.transaction_history.map((txn, idx) => (
                      <TableRow 
                        key={idx}
                        sx={{ 
                          bgcolor: idx % 2 === 0 ? 'white' : '#FAFAFA',
                          '&:last-child td': { border: 0 }
                        }}
                      >
                        <TableCell sx={{ py: 1, fontSize: '0.75rem', color: 'text.secondary' }}>
                          {idx + 1}
                        </TableCell>
                        <TableCell sx={{ py: 1, fontSize: '0.75rem' }}>
                          {txn.timestamp 
                            ? formatDate(txn.timestamp) 
                            : '—'}
                        </TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Chip 
                            label={txn.method || '—'} 
                            size="small" 
                            sx={{ 
                              fontSize: '0.68rem', 
                              height: 20,
                              bgcolor: txn.method === 'online' ? '#E3F2FD' : '#F3E5F5',
                              color: txn.method === 'online' ? '#1565C0' : '#6A1B9A',
                              textTransform: 'capitalize'
                            }} 
                          />
                        </TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Chip 
                            label={txn.status || '—'} 
                            size="small"
                            color={
                              txn.status === 'success' ? 'success' :
                              txn.status === 'refunded' ? 'info' :
                              txn.status === 'failed' ? 'error' : 'warning'
                            }
                            sx={{ fontSize: '0.68rem', height: 20 }}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 1, fontSize: '0.7rem', color: '#475569', maxWidth: 140 }}>
                          <Typography 
                            variant="caption" 
                            sx={{ 
                              display: 'block',
                              wordBreak: 'break-all',
                              lineHeight: 1.3
                            }}
                          >
                            {txn.refund_id || txn.payment_id || '—'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}

          {/* No transaction history fallback */}
          {(!selectedOrder.payment?.transaction_history || 
            selectedOrder.payment.transaction_history.length === 0) && (
            <Box sx={{ 
              mt: 1, 
              p: 1.5, 
              bgcolor: '#F9FAFB', 
              borderRadius: 1, 
              textAlign: 'center',
              border: '1px dashed #E0E0E0'
            }}>
              <Typography variant="caption" color="text.secondary">
                No transaction history available
              </Typography>
            </Box>
          )}
        </Box>
          </Paper>
        )}
   {!selectedOrder?.assigned_agent_id && selectedOrder.order_status==='dispatched' &&( <AssignAgent selectedOrder={selectedOrder} orderType="medicine" deliveryType='medicine' agentRole='delivery'
    onAssignmentSuccess={(data,id) => {
    console.log("Assignment Success:", data);

    // Or update local state
    setSelectedOrder(prev => ({
      ...prev,
      assigned_agent_id:id
    }));
    fetchAgentDetails(id);
  }}></AssignAgent>)}

          {/* Update Order Status */}
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Update Order Status
            </Typography>
            <Grid container spacing={1}>
              {["awaiting_bill","confirmed","bill_generated","dispatched","delivered","cancelled","returned","partially_returned"].map((status) => (
                <Grid item xs={6} key={status}>
                  <Button
                    variant={selectedOrder.order_status === status ? "contained" : "outlined"}
                    onClick={() => updateOrderStatus(selectedOrder.order_id, status)}
                    disabled={updating}
                    fullWidth
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      borderColor: "#006D77",
                      color: selectedOrder.order_status === status ? "#fff" : "#006D77",
                      backgroundColor: selectedOrder.order_status === status ? "#006D77" : "transparent",
                      "&:hover": {
                        backgroundColor: selectedOrder.order_status === status ? "#005560" : "rgba(0, 109, 119, 0.08)",
                        borderColor: "#006D77",
                      },
                    }}
                  >
                    {statusLabelMap[status]}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Paper>

        </Box>
      </DialogContent>


      <DialogActions sx={{ p: 2, gap: 1, bgcolor: '#F9FAFB' }}>
        {/* Only show buttons if NOT a parent order with children */}
        {!(selectedOrder?.is_parent && selectedOrder?.has_children) && (
          <>
            <Button
              variant="contained"
              startIcon={<BellIcon />}
              onClick={sendNotification}
              fullWidth
              sx={{ 
                bgcolor: '#5EC1C6', 
                '&:hover': { bgcolor: '#1A7F88' },
                fontWeight: 600,
                textTransform: 'none',
                py: 1.2
              }}
            >
              Send Notification
            </Button>

            {selectedOrder && 
              selectedOrder.items && 
              (selectedOrder.items.length > 1 || 
              (selectedOrder.items.length === 1 && selectedOrder.items[0].quantity > 1)) && 
              !['cancelled', 'delivered', 'completed','returned','partially_returned'].includes(selectedOrder.order_status) && (
              <Button
                variant="contained"
                sx={{ 
                  bgcolor: '#1A7F88', 
                  '&:hover': { bgcolor: '#5EC1C6' },
                  fontWeight: 600,
                  textTransform: 'none',
                  py: 1.2
                }}
                startIcon={<ContentCutIcon />}
                onClick={handleOpenSplitDialog}
                fullWidth
              >
                Split Order
              </Button>
            )}
          </>
        )}
            {(selectedOrder?.order_status === "delivered" || selectedOrder?.order_status === "partially_returned") && (
            <Button
              variant="contained"
              sx={{
                bgcolor: '#D32F2F',
                '&:hover': { bgcolor: '#B71C1C' },
                fontWeight: 600,
                textTransform: 'none',
                py: 1.2
              }}
              startIcon={<KeyboardReturnIcon />}
              onClick={handleOpenReturnDialog}
              fullWidth
            >
              Return Items
            </Button>)}
            
            
        
        {/* Show message for parent orders with children */}
        {selectedOrder?.is_parent && selectedOrder?.has_children && (
          <Box sx={{ width: '100%', textAlign: 'center', py: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
              ***This parent order has been split. Navigate to child orders to perform actions.***
            </Typography>
          </Box>
        )}
      </DialogActions>
    </>
  )}
</Dialog>
           
<Dialog
  open={returnDialogOpen}
  onClose={handleCloseReturnDialog}
  maxWidth="md"
  fullWidth
>
  <DialogTitle
    sx={{
      bgcolor: '#D32F2F',
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}
  >
    <Box>
      <Typography variant="h6" fontWeight="bold">
        Return Items
      </Typography>

      <Typography variant="caption">
        Order: {selectedOrder?.order_id}
      </Typography>
    </Box>

    <IconButton
      onClick={handleCloseReturnDialog}
      sx={{ color: 'white' }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: '#FFEBEE' }}>
            <TableCell>Medicine</TableCell>
            <TableCell align="center">
              Ordered Qty
            </TableCell>
            <TableCell align="center">
              Return Qty
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {returnItems.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <Typography fontWeight="600">
                  {item.medicine_name}
                </Typography>
              </TableCell>

              <TableCell align="center">
                <Chip
                  label={item.ordered_quantity}
                  size="small"
                  sx={{
                    bgcolor: '#1976D2',
                    color: 'white'
                  }}
                />
              </TableCell>

              <TableCell align="center">
                <TextField
                  type="number"
                  size="small"
                  value={item.return_quantity}
                  onChange={(e) =>
                    handleReturnQtyChange(
                      index,
                      e.target.value
                    )
                  }
                  inputProps={{
                    min: 0,
                    max: item.ordered_quantity,
                    style: {
                      textAlign: 'center',
                      fontWeight: 'bold'
                    }
                  }}
                  sx={{ width: 90 }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <FormControlLabel
  control={
    <Checkbox
      checked={returnAllItems}
      onChange={(e) => setReturnAllItems(e.target.checked)}
    />
  }
  label="Return All Items"
/>
<Select
  value={refundMethod}
  onChange={(e) => setRefundMethod(e.target.value)}
  fullWidth
  size="small"
>
  <MenuItem value="cash">Cash</MenuItem>
  <MenuItem value="online">Online</MenuItem>
  <MenuItem disabled value="credit_note">Credit Note</MenuItem>
</Select>

    <TextField
      fullWidth
      multiline
      rows={3}
      label="Return Reason"
      value={returnReason}
      onChange={(e) =>
        setReturnReason(e.target.value)
      }
      sx={{ mt: 3 }}
    />
  </DialogContent>

  <DialogActions sx={{ p: 2 }}>
    <Button
      onClick={handleCloseReturnDialog}
      variant="outlined"
    >
      Cancel
    </Button>

    <Button
      onClick={handleSubmitReturn}
      variant="contained"
      color="error"
      disabled={processingReturn}
      startIcon={
        processingReturn
          ? <CircularProgress size={18} color="inherit" />
          : <KeyboardReturnIcon />
      }
    >
      {processingReturn
        ? "Processing..."
        : "Confirm Return"}
    </Button>
  </DialogActions>
</Dialog>


      {/* Prescription Viewer Dialog */}
<Dialog
open={prescriptionViewerOpen}
onClose={handleClosePrescriptionViewer}
maxWidth="lg"
fullWidth
>
<DialogTitle sx={{ bgcolor: '#006D77', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
<Typography variant="h6" fontWeight="bold">Prescription Viewer</Typography>
<IconButton onClick={handleClosePrescriptionViewer} sx={{ color: 'white' }}>
<CloseIcon />
</IconButton>
</DialogTitle>

<DialogContent sx={{ p: 0, bgcolor: '#F5F5F5' }}>
<Box sx={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
{prescriptionType === 'image' ? (
<Box
  component="img"
  src={selectedPrescriptionUrl}
  alt="Prescription"
  sx={{
    maxWidth: '100%',
    maxHeight: '70vh',
    objectFit: 'contain',
    borderRadius: 1,
    boxShadow: 3
  }}
/>
) : prescriptionType === 'pdf' ? (
  <iframe
  src={`${selectedPrescriptionUrl}#view=FitH`}
  style={{
    width: '100%',
    height: '70vh',
    border: 'none',
    borderRadius: '4px'
  }}
  title="Prescription PDF"
  type="application/pdf"
/>
) : (
<Typography variant="h6" color="text.secondary">
  Preview not available. Click download to view the file.
</Typography>
)}
</Box>
</DialogContent>

<DialogActions sx={{ p: 2, bgcolor: 'white' }}>
<Button
  variant="contained"
  startIcon={<DownloadIcon />}
  onClick={() =>
    handleDownloadPrescription(selectedOrder.order_id, selectedPrescriptionUrl)
  }
  sx={{
    bgcolor: '#006D77',
    '&:hover': { bgcolor: '#005560' }
  }}
>
  Download
</Button>

<Button onClick={handleClosePrescriptionViewer} variant="outlined">
Close
</Button>
</DialogActions>
</Dialog>


<Dialog 
  open={splitDialogOpen} 
  onClose={handleCloseSplitDialog} 
  maxWidth="md" 
  fullWidth
>
  <DialogTitle sx={{ bgcolor: '#006D77', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Box>
      <Typography variant="h6" fontWeight="bold">Split Order: {selectedOrder?.order_id}</Typography>
      <Typography variant="caption">Adjust quantities for each medicine</Typography>
    </Box>
    <IconButton onClick={handleCloseSplitDialog} sx={{ color: 'white' }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    <Box sx={{ py: 2 }}>
      <Paper sx={{ p: 2, mb: 3, bgcolor: '#FFF3CD', borderLeft: '4px solid #FFC107' }}>
        <Typography variant="body2" fontWeight="600" color="#856404" gutterBottom>
          ℹ️ Instructions
        </Typography>
        <Typography variant="body2" color="#856404">
          • Adjust quantities for each medicine using the input fields<br/>
          • <strong>Keep Quantity:</strong> Amount to deliver in current order<br/>
          • <strong>Split Quantity:</strong> Amount to move to new order<br/>
          • Total must equal original ordered quantity<br/>
          • Example: Ordered 60 tablets → Keep 50, Split 10
        </Typography>
      </Paper>

      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ color: '#006D77' }}>
        Adjust Quantities
      </Typography>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FA' }}>
              <TableCell><Typography variant="caption" fontWeight="bold">Medicine</Typography></TableCell>
              <TableCell align="center" width={100}>
                <Typography variant="caption" fontWeight="bold">Original Qty</Typography>
              </TableCell>
              <TableCell align="center" width={150}>
                <Typography variant="caption" fontWeight="bold">Keep Qty<br/>(Deliver Now)</Typography>
              </TableCell>
              <TableCell align="center" width={150}>
                <Typography variant="caption" fontWeight="bold">Split Qty<br/>(New Order)</Typography>
              </TableCell>
              <TableCell width={200}>
                <Typography variant="caption" fontWeight="bold">Quick Actions</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedItemsForSplit.map((item, index) => {
              const isValid = item.keep_quantity + item.split_quantity === item.original_quantity;
              const hasKeepQty = item.keep_quantity > 0;
              const hasSplitQty = item.split_quantity > 0;
              
              return (
                <TableRow 
                  key={index}
                >
                  <TableCell>
                    <Typography variant="body2" fontWeight="600">
                      {item.medicine_name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      ₹{item.discounted_price || item.price} per unit
                    </Typography>
                  </TableCell>
                  
                  <TableCell align="center">
                    <Chip 
                      label={item.original_quantity} 
                      size="small" 
                      sx={{ 
                        bgcolor: '#2196F3',
                        color: 'white',
                        fontWeight: 600
                      }}
                    />
                  </TableCell>
                  
                  <TableCell align="center">
                    <TextField
                      type="number"
                      size="small"
                      value={item.keep_quantity}
                      onChange={(e) => handleQuantityChange(index, 'keep_quantity', e.target.value)}
                      inputProps={{ 
                        min: 0, 
                        max: item.original_quantity,
                        style: { textAlign: 'center', fontWeight: 'bold' }
                      }}
                      sx={{ 
                        width: 80,
                        '& .MuiOutlinedInput-root': {
                          bgcolor: hasKeepQty ? '#C8E6C9' : 'white',
                          '&.Mui-focused': {
                            bgcolor: hasKeepQty ? '#C8E6C9' : 'white',
                          }
                        }
                      }}
                    />
                  </TableCell>
                  
                  <TableCell align="center">
                    <TextField
                      type="number"
                      size="small"
                      value={item.split_quantity}
                      onChange={(e) => handleQuantityChange(index, 'split_quantity', e.target.value)}
                      inputProps={{ 
                        min: 0, 
                        max: item.original_quantity,
                        style: { textAlign: 'center', fontWeight: 'bold' }
                      }}
                      sx={{ 
                        width: 80,
                        '& .MuiOutlinedInput-root': {
                          bgcolor: hasSplitQty ? '#FFE082' : 'white',
                          '&.Mui-focused': {
                            bgcolor: hasSplitQty ? '#FFE082' : 'white',
                          }
                        }
                      }}
                    />
                  </TableCell>
                  
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleKeepAll(index)}
                        sx={{ 
                          fontSize: '0.7rem', 
                          py: 0.3,
                          borderColor: '#006D77',
                          color: '#006D77',
                          '&:hover': { bgcolor: '#CFF3F5' }
                        }}
                      >
                        Keep All
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleMoveAllToSplit(index)}
                        sx={{ 
                          fontSize: '0.7rem', 
                          py: 0.3,
                          borderColor: '#F59E0B',
                          color: '#F59E0B',
                          '&:hover': { bgcolor: '#FFF3CD' }
                        }}
                      >
                        Split All
                      </Button>
                    </Box>
                    {!isValid && (
                      <Typography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
                         Total must equal {item.original_quantity}
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
        <Paper sx={{ flex: 1, p: 2, bgcolor: '#CFF3F5', border: '1px solid #83C5BE' }}>
          <Typography variant="subtitle2" fontWeight="bold" color="#155724" gutterBottom>
             Items to Deliver Now
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="#006D77">
            {selectedItemsForSplit.reduce((sum, item) => sum + item.keep_quantity, 0)} units
          </Typography>
          <Typography variant="caption" color="#155724">
            Stay in current order: {selectedOrder?.order_id}
          </Typography>
        </Paper>

        <Paper sx={{ flex: 1, p: 2, bgcolor: '#FFF3CD', border: '1px solid #FFC107' }}>
          <Typography variant="subtitle2" fontWeight="bold" color="#856404" gutterBottom>
             Items to Split Out
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="#F59E0B">
            {selectedItemsForSplit.reduce((sum, item) => sum + item.split_quantity, 0)} units
          </Typography>
          <Typography variant="caption" color="#856404">
            Will create new order
          </Typography>
        </Paper>
      </Box>

      <TextField
        fullWidth
        multiline
        rows={3}
        label="Reason for Split (Optional)"
        placeholder="e.g., Only 50 tablets in stock, customer request, etc."
        value={splitReason}
        onChange={(e) => setSplitReason(e.target.value)}
        sx={{ mt: 3 }}
      />
    </Box>
  </DialogContent>

  <DialogActions sx={{ p: 2, gap: 1 }}>
    <Button
      onClick={handleCloseSplitDialog}
      variant="outlined"
      sx={{ borderColor: '#006D77', color: '#006D77' }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleSubmitSplitOrder}
      variant="contained"
      disabled={
        splittingOrder || 
        selectedItemsForSplit.some(item => item.keep_quantity + item.split_quantity !== item.original_quantity) ||
        selectedItemsForSplit.every(item => item.split_quantity === 0) ||
        selectedItemsForSplit.every(item => item.keep_quantity === 0)
      }
      startIcon={splittingOrder ? <CircularProgress size={20} color="inherit" /> : <ContentCutIcon />}
      sx={{ 
        bgcolor: '#006D77', 
        '&:hover': { bgcolor: '#1A7F88' },
        minWidth: 150
      }}
    >
      {splittingOrder ? 'Splitting...' : 'Confirm Split'}
    </Button>
  </DialogActions>
</Dialog>




      <CustomDialog
        open={customDialog.show}
        message={customDialog.message}
        type={customDialog.type}
        title={customDialog.title}
        onClose={handleCloseCustomDialog}
        buttonText="OK"
      />
    </Box>
  );
};

export default MedicineOrdersScreen;